// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import AdminNavbar from '../../components/AdminNavbar';
// import axiosInstance from '../../services/axiosInstance';
// import AccessDeniedMessage from '../../components/AccessDeniedMessage';
// import DrinkSchedule from '../../components/DrinkSchedule';
// import CreateContainerComponent from '../../components/CreateContainerComponentEtablissement';
// import CategoryManager from '../../components/CategoryManager';
// import CategorySelectorMultiple from '../../components/CategorySelectorMultiple';

// async function fetchEstablishment(id) {
//   try {
//     const res = await axiosInstance.get(`/establishments/${id}`);
//     return res.data.establishment;
//   } catch (err) {
//     if (err.response && err.response.data && err.response.data.error) {
//       return false;
//     } else {
//       alert("Une erreur est survenue lors de la récupération de l'établissement.");
//     }
//     console.error(err);
//     return null;
//   }
// }

// function ManageProductsPage() {
//   const { id_etablissement } = useParams();
//   const navigate = useNavigate();
  
//   // États existants conservés
//   const [establishment, setEstablishment] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [drinks, setDrinks] = useState([]);
//   const [selectedDrinkId, setSelectedDrinkId] = useState(null);
//   const [price, setPrice] = useState('');
//   const [discount, setDiscount] = useState('');
//   const [name_etablissement, SetNameEtablissement] = useState('');
//   const [product_category, SetProduct_category] = useState('drink');
//   const [forGourd, setForGourd] = useState(false);
//   const [forMug, setForMug] = useState(false);
//   const [forBox, setForBox] = useState(false);
//   const [refusedContainers, setRefusedContainers] = useState([]);
//   const [containers, setContainers] = useState([]);
//   const [containers_chr, setContainers_chr] = useState([]);
//   const [unitPrice, setUnitPrice] = useState('');
//   const [pricingMode, setPricingMode] = useState('perLiter');
//   const [pricingMode2, setPricingMode2] = useState('perLiter');
//   const [unitVolume, setUnitVolume] = useState('');
//   const [imageFile, setImageFile] = useState(null);
//   const [hasAccess, sethasAccess] = useState(true);
//   const [bio, setBio] = useState(false);
//   const [filteredContainers, setFilteredContainers] = useState([]);
//   const [isVisible, setIsVisible] = useState(true);
//   const [drinkName, setDrinkName] = useState('');
//   const [description, setDescription] = useState('');
//   const [category_boisson, setCategory_boisson] = useState('');
//   const [selectedContainerId, setSelectedContainerId] = useState('');
//   const [selectedContainerId2, setSelectedContainerId2] = useState('');
//   const [currentCategory, setCurrentCategory] = useState('');
//   const [categories, setCategories] = useState([]);
//   const [drinkSchedule, setDrinkSchedule] = useState([]);
//   const [isEnterpriseCodeRequired, setIsEnterpriseCodeRequired] = useState(false);
//   const [contenantRequired, setContenantRequired] = useState(false);
//   const [hasAgreed, setHasAgreed] = useState(false);
//   const [containerName, setContainerName] = useState('');
//   const [containerBrand, setContainerBrand] = useState('');
//   const [containerVolume, setContainerVolume] = useState('');
//   const [containerImage, setContainerImage] = useState(null);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [selectedProductForEdit, setSelectedProductForEdit] = useState(null);
//   const [selectedProductForEdit2, setSelectedProductForEdit2] = useState(null);
//   const [categories_boisson, setCategories_boisson] = useState([]);
//   const [categoryOptions, setCategoryOptions] = useState([]);
//   const [selectedProductIngredients, setSelectedProductIngredients] = useState([]);
//   const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
//   const [selectedCategoryPath, setSelectedCategoryPath] = useState([]);
//   const [categories_easydrinks, setCategories_easydrinks] = useState([]);
//   const [editSelectedCategoryPath, setEditSelectedCategoryPath] = useState([]);
//   const [productType, setProductType] = useState('drink');
//   const [editOfferedDrinks, setEditOfferedDrinks] = useState(0);
//   const [offeredDrinks, setOfferedDrinks] = useState(0);
//   const [canBeOffered, setCanBeOffered] = useState(false);
//   const [drinkcCanBeOffered, setDrinksCanBeOffered] = useState(false);
//   const [depositPrice, setDepositPrice] = useState('');
//   const [acceptsCustomerContainer, setAcceptsCustomerContainer] = useState(false);
//   const [preconditionedWithDeposit, setPreconditionedWithDeposit] = useState(false);
//   const [isVegetarian, setIsVegetarian] = useState(false);
//   const [isContainerModalOpen, setIsContainerModalOpen] = useState(false);

//   // Nouveaux états pour les catégories personnalisées multiples
//   const [customCategories, setCustomCategories] = useState([]);
//   const [selectedCustomCategoryIds, setSelectedCustomCategoryIds] = useState([]);
//   const [editSelectedCustomCategoryIds, setEditSelectedCustomCategoryIds] = useState([]);

//   // Nouveau état pour le modal d'ajout
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);

//   // État pour le filtre des produits
//   const [filterCategory, setFilterCategory] = useState('all');
//   const [searchTerm, setSearchTerm] = useState('');

//   const [updatingVisibility, setUpdatingVisibility] = useState(null);

//   // Styles modernisés
//   const styles = {
//     container: {
//       backgroundColor: '#f8fafc',
//       minHeight: '100vh',
//       fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
//     },
//     backButton: {
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px',
//       padding: '12px 20px',
//       margin: '20px',
//       backgroundColor: '#f1f5f9',
//       color: '#475569',
//       border: 'none',
//       borderRadius: '8px',
//       fontSize: '14px',
//       fontWeight: '500',
//       cursor: 'pointer',
//       textDecoration: 'none',
//       transition: 'all 0.2s ease-in-out'
//     },
//     content: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '32px'
//     },
//     header: {
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       padding: '32px',
//       marginBottom: '32px',
//       boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
//       border: '1px solid #e2e8f0',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center'
//     },
//     headerContent: {
//       display: 'flex',
//       flexDirection: 'column'
//     },
//     title: {
//       fontSize: '32px',
//       fontWeight: '700',
//       color: '#1e293b',
//       margin: '0 0 8px 0'
//     },
//     subtitle: {
//       fontSize: '16px',
//       color: '#64748b',
//       margin: 0
//     },
//     addButton: {
//       backgroundColor: '#059669',
//       color: '#ffffff',
//       border: 'none',
//       borderRadius: '12px',
//       padding: '16px 24px',
//       fontSize: '16px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       transition: 'all 0.2s ease-in-out',
//       boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
//     },
//     section: {
//       backgroundColor: '#ffffff',
//       borderRadius: '12px',
//       padding: '24px',
//       boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
//       border: '1px solid #e2e8f0',
//       marginBottom: '24px'
//     },
//     sectionTitle: {
//       fontSize: '24px',
//       fontWeight: '600',
//       color: '#1e293b',
//       marginBottom: '20px',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px'
//     },
//     sectionTitleSmall: {
//       fontSize: '18px',
//       fontWeight: '600',
//       color: '#1e293b',
//       marginBottom: '16px',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px'
//     },
//     filterSection: {
//       display: 'flex',
//       gap: '16px',
//       marginBottom: '24px',
//       flexWrap: 'wrap',
//       alignItems: 'center'
//     },
//     searchBox: {
//       flex: 1,
//       minWidth: '200px',
//       padding: '12px 16px',
//       border: '1px solid #d1d5db',
//       borderRadius: '8px',
//       fontSize: '14px'
//     },
//     filterButtons: {
//       display: 'flex',
//       gap: '8px',
//       flexWrap: 'wrap'
//     },
//     filterButton: {
//       padding: '8px 16px',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '14px',
//       cursor: 'pointer',
//       backgroundColor: '#ffffff',
//       transition: 'all 0.2s ease-in-out'
//     },
//     filterButtonActive: {
//       backgroundColor: '#059669',
//       color: '#ffffff',
//       borderColor: '#059669'
//     },
//     toggleSection: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '16px',
//       padding: '16px',
//       backgroundColor: '#f8fafc',
//       borderRadius: '8px',
//       border: '2px solid #e2e8f0'
//     },
//     toggleButton: {
//       position: 'relative',
//       width: '60px',
//       height: '32px',
//       backgroundColor: '#cbd5e1',
//       borderRadius: '16px',
//       border: 'none',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s ease-in-out'
//     },
//     toggleButtonActive: {
//       backgroundColor: '#059669'
//     },
//     toggleThumb: {
//       position: 'absolute',
//       top: '2px',
//       left: '2px',
//       width: '28px',
//       height: '28px',
//       backgroundColor: '#ffffff',
//       borderRadius: '50%',
//       transition: 'transform 0.2s ease-in-out',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
//     },
//     toggleThumbActive: {
//       transform: 'translateX(28px)'
//     },
//     inputGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '8px',
//       marginBottom: '16px'
//     },
//     label: {
//       fontSize: '14px',
//       fontWeight: '500',
//       color: '#374151'
//     },
//     input: {
//       padding: '12px 16px',
//       border: '1px solid #d1d5db',
//       borderRadius: '8px',
//       fontSize: '16px',
//       transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
//       outline: 'none',
//       backgroundColor: '#ffffff'
//     },
//     textarea: {
//       padding: '12px 16px',
//       border: '1px solid #d1d5db',
//       borderRadius: '8px',
//       fontSize: '16px',
//       minHeight: '120px',
//       resize: 'vertical',
//       fontFamily: 'inherit',
//       outline: 'none'
//     },
//     select: {
//       padding: '12px 16px',
//       border: '1px solid #d1d5db',
//       borderRadius: '8px',
//       fontSize: '16px',
//       backgroundColor: '#ffffff',
//       cursor: 'pointer',
//       outline: 'none'
//     },
//     checkbox: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       padding: '12px',
//       backgroundColor: '#f8fafc',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       cursor: 'pointer',
//       marginBottom: '8px'
//     },
//     checkboxInput: {
//       width: '18px',
//       height: '18px',
//       accentColor: '#059669'
//     },
//     radioGroup: {
//       display: 'flex',
//       gap: '16px',
//       flexWrap: 'wrap',
//       marginBottom: '16px'
//     },
//     radioOption: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       padding: '12px 16px',
//       backgroundColor: '#f8fafc',
//       border: '2px solid #e2e8f0',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       transition: 'all 0.2s ease-in-out'
//     },
//     radioOptionSelected: {
//       backgroundColor: '#dcfdf7',
//       borderColor: '#059669'
//     },
//     button: {
//       padding: '12px 24px',
//       border: 'none',
//       borderRadius: '8px',
//       fontSize: '16px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.2s ease-in-out',
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px'
//     },
//     primaryButton: {
//       backgroundColor: '#059669',
//       color: '#ffffff'
//     },
//     secondaryButton: {
//       backgroundColor: '#f1f5f9',
//       color: '#475569'
//     },
//     dangerButton: {
//       backgroundColor: '#dc2626',
//       color: '#ffffff'
//     },
//     productGrid: {
//       display: 'grid',
//       gap: '24px'
//     },
//     productCard: {
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       padding: '24px',
//       boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
//       border: '1px solid #e2e8f0',
//       display: 'grid',
//       gridTemplateColumns: '200px 1fr auto',
//       gap: '24px',
//       alignItems: 'start'
//     },
//     productImage: {
//       width: '200px',
//       height: '150px',
//       objectFit: 'cover',
//       borderRadius: '12px'
//     },
//     productInfo: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '12px'
//     },
//     productName: {
//       fontSize: '20px',
//       fontWeight: '600',
//       color: '#1e293b',
//       margin: 0
//     },
//     productDescription: {
//       fontSize: '14px',
//       color: '#64748b',
//       lineHeight: '1.5'
//     },
//     productTags: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '8px'
//     },
//     tag: {
//       padding: '4px 12px',
//       backgroundColor: '#f1f5f9',
//       color: '#475569',
//       borderRadius: '20px',
//       fontSize: '12px',
//       fontWeight: '500'
//     },
//     tagGreen: {
//       backgroundColor: '#dcfdf7',
//       color: '#059669'
//     },
//     tagRed: {
//       backgroundColor: '#fef2f2',
//       color: '#dc2626'
//     },
//     tagBlue: {
//       backgroundColor: '#dbeafe',
//       color: '#2563eb'
//     },
//     productActions: {
//       display: 'flex',
//       gap: '12px',
//       minWidth: '180px',
//       alignItems: 'flex-start'
//     },
//     reorderButtons: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '2px'
//     },
//     reorderButton: {
//       width: '30px',
//       height: '30px',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       backgroundColor: '#ffffff',
//       color: '#374151',
//       cursor: 'pointer',
//       fontSize: '16px',
//       fontWeight: 'bold',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       transition: 'all 0.2s ease-in-out'
//     },
//     actionButtons: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '8px',
//       flex: 1
//     },
//     modal: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 1000,
//       padding: '20px'
//     },
//     modalContent: {
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       padding: '32px',
//       width: '100%',
//       maxWidth: '900px',
//       maxHeight: '90vh',
//       overflow: 'auto'
//     },
//     modalTitle: {
//       fontSize: '24px',
//       fontWeight: '700',
//       color: '#1e293b',
//       marginBottom: '24px'
//     },
//     modalActions: {
//       display: 'flex',
//       gap: '12px',
//       marginTop: '32px',
//       justifyContent: 'flex-end'
//     },
//     containerOption: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       padding: '12px',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       marginBottom: '8px'
//     },
//     containerImage: {
//       width: '40px',
//       height: '40px',
//       objectFit: 'cover',
//       borderRadius: '4px'
//     },
//     emptyState: {
//       textAlign: 'center',
//       padding: '40px',
//       color: '#64748b'
//     },
//     emptyIcon: {
//       fontSize: '48px',
//       marginBottom: '16px'
//     },
//     emptyTitle: {
//       fontSize: '18px',
//       fontWeight: '600',
//       color: '#374151',
//       marginBottom: '8px'
//     },
//     emptyDescription: {
//       fontSize: '14px',
//       color: '#6b7280'
//     },
//     categoryFilters: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '8px',
//       marginTop: '12px'
//     },
//     categoryFilterButton: {
//       padding: '6px 12px',
//       border: '1px solid #e2e8f0',
//       borderRadius: '16px',
//       fontSize: '12px',
//       cursor: 'pointer',
//       backgroundColor: '#ffffff',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '6px',
//       transition: 'all 0.2s ease-in-out'
//     }
//   };

//   // useEffect conservés
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await axios.get('https://backend.csibon.app/categories_easy_drinks/categories');
//         setCategories_easydrinks(response.data);
//       } catch (error) {
//         console.error('Erreur lors de la récupération des catégories', error);
//       }
//     };
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (productType === 'food') {
//       setForGourd(false);
//       setForMug(false);
//       setBio(false);
//       setForBox(true);
//       setPricingMode("perUnit");
//       setUnitVolume(null);
//       SetProduct_category('food');
//     } else {
//       setForBox(false);
//       SetProduct_category('drink');
//     }
//   }, [productType]);

//   useEffect(() => {
//     const fetchContainers = async () => {
//       try {
//         const response = await axiosInstance.get('/drinks/containers');
//         setContainers(response.data);
//         filterContainers(response.data, forGourd, forMug);
//       } catch (error) {
//         console.error('Erreur lors de la récupération des contenants', error);
//       }
//     };
//     fetchContainers();
//   }, []);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         console.log()
//         const response = await axiosInstance.get(`/drinks/drink-establishment-links/${id_etablissement}`);
//         setProducts(response.data);
//         console.log("Produits récupérés:", response.data);
//       } catch (error) {
//         console.error('Erreur lors de la récupération des produits', error);
//       }
//     };
//     fetchProducts();
//   }, [id_etablissement]);

//   useEffect(() => {
//     const fetchDrinks = async () => {
//       try {
//         const response = await axiosInstance.get('/drinks/drinks');
//         setDrinks(response.data);
//       } catch (error) {
//         console.error('Erreur lors de la récupération des boissons', error);
//       }
//     };
//     fetchDrinks();
//   }, []);

//   useEffect(() => {
//     const fetchAndSetEstablishment = async () => {
//       const establishmentData = await fetchEstablishment(id_etablissement);
//       if (establishmentData) {
//         SetNameEtablissement(establishmentData.name);
//         sethasAccess(true);
//       } else {
//         sethasAccess(false);
//       }
//     };
//     fetchAndSetEstablishment();
//   }, [id_etablissement]);

//   useEffect(() => {
//     const fetchContainers = async () => {
//       console.log(`https://backend.csibon.app/container_chr/containers/establishment/${id_etablissement}`)
//       try {
//         const response = await fetch(`https://backend.csibon.app/container_chr/containers/establishment/${id_etablissement}`);
//         if (!response.ok) {
//           throw new Error('Erreur réseau lors de la récupération des contenants.');
//         }
//         let containers_chr = await response.json();
//         setContainers_chr(containers_chr);
//       } catch (error) {
//         console.error('Erreur lors de la récupération des contenants:', error);
//       }
//     };
//     fetchContainers();
//   }, [id_etablissement]);

//   useEffect(() => {
//     filterContainers(containers, forGourd, forMug, forBox);
//   }, [forGourd, forMug, forBox, containers]);

//   useEffect(() => {
//     if (selectedProductForEdit2) {
//       const initialPricingMode = selectedProductForEdit.unit_price != null ? "perUnit" : "perLiter";
//       setPricingMode2(initialPricingMode);
//     }
//   }, [selectedProductForEdit2]);

//   // Fonctions pour gérer les catégories personnalisées
//   const handleCategoriesChange = (updatedCategories) => {
//     setCustomCategories(updatedCategories);
//   };

//   const renderCustomCategories = (categoryIds) => {
//     if (!categoryIds || categoryIds.length === 0) return null;
    
//     const productCategories = customCategories.filter(cat => 
//       categoryIds.includes(cat.id)
//     );
    
//     if (productCategories.length === 0) return null;
  
//     return (
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
//         {productCategories.map(category => (
//           <span 
//             key={category.id}
//             style={{
//               ...styles.tag,
//               backgroundColor: '#f1f5f9',
//               color: '#475569',
//               border: '1px solid #e2e8f0'
//             }}
//           >
//             {category.full_path || category.name}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   // Fonction pour déplacer un produit
//   const moveProduct = async (productId, direction) => {
//     try {
//       const endpoint = direction === 'up' ? 'move-up' : 'move-down';
//       const response = await axiosInstance.put(`/drinks/drink-establishment-links/${productId}/${endpoint}`);

      
//       if (response.status === 200) {
        

//         // Recharger les produits pour refléter le nouvel ordre
//         const productsResponse = await axiosInstance.get(`/drinks/drink-establishment-links/${id_etablissement}`);
//         setProducts(productsResponse.data);
        
//         // Optionnel : afficher un message de succès discret
//         console.log(`Produit déplacé ${direction === 'up' ? 'vers le haut' : 'vers le bas'} avec succès`);
//       }
//     } catch (error) {
//       console.error('Erreur lors du déplacement du produit', error);
//       if (error.response?.data?.message) {
//         alert(error.response.data.message);
//       } else {
//         alert('Erreur lors du déplacement du produit');
//       }
//     }
//   };

//   // Fonctions conservées
//   const filterContainers = (containers, forGourd, forMug, forBox) => {
//     let filtered = containers;
//     if (forGourd) {
//       filtered = containers.filter(container => container.gourde);
//     } else if (forMug) {
//       filtered = containers.filter(container => container.mug);
//     } else if (forBox) {
//       filtered = containers.filter(container => container.box);
//     }
//     setFilteredContainers(filtered);
//   };

//   const getCurrentCategories = (level) => {
//     let currentCategories = categories_easydrinks;
//     for (let i = 0; i < level; i++) {
//       const categoryId = selectedCategoryPath[i];
//       const category = currentCategories.find(cat => cat.id === categoryId);
//       if (category && category.subCategories) {
//         currentCategories = category.subCategories;
//       } else {
//         return [];
//       }
//     }
//     return currentCategories;
//   };

//   const handleCategoryChange = (categoryId, level) => {
//     if (categoryId === "") {
//       setSelectedCategoryPath(selectedCategoryPath.slice(0, level));
//     } else {
//       const newSelectedPath = [...selectedCategoryPath.slice(0, level), categoryId];
//       setSelectedCategoryPath(newSelectedPath);
//     }
//   };

//   const renderCategorySelect = (level) => {
//     const currentCategories = getCurrentCategories(level);
//     if (level !== 0 && currentCategories.length === 0) return null;

//     return (
//       <div key={level} style={styles.inputGroup}>
//         <label style={styles.label}>
//           {level === 0 ? 'Catégorie principale' : `Sous-catégorie niveau ${level}`}
//         </label>
//         <select
//           value={selectedCategoryPath[level] || ''}
//           onChange={(e) => handleCategoryChange(e.target.value, level)}
//           style={styles.select}
//         >
//           {level !== 0 && <option value=""><em>Pas de sous-catégorie</em></option>}
//           {currentCategories.map((cat) => (
//             <option key={cat.id} value={cat.id}>{cat.name}</option>
//           ))}
//         </select>
//       </div>
//     );
//   };

//   function renderEditCategorySelect(level, categories) {
//     console.log("editSelectedCategoryPath", editSelectedCategoryPath)

//     let currentCategories = categories;
//     for (let i = 0; i < level; i++) {
//       const parentCategoryId = editSelectedCategoryPath[i];
//       const parentCategory = currentCategories.find(cat => cat.id === parentCategoryId);
//       if (!parentCategory || !parentCategory.subCategories) {
//         return null;
//       }
//       currentCategories = parentCategory.subCategories;
//     }

//     const handleEditCategoryChange = (selectedCategoryId, level) => {
//       let newPath = [...editSelectedCategoryPath];
//       newPath[level] = selectedCategoryId;
//       newPath = newPath.slice(0, level + 1);
      
//       let currentCategory = categories_easydrinks;
//       for (let i = 0; i <= level; i++) {
//         const categoryId = newPath[i];
//         const nextCategory = currentCategory.find(cat => cat.id === categoryId);
//         if (nextCategory && nextCategory.subCategories && nextCategory.subCategories.length > 0) {
//           currentCategory = nextCategory.subCategories;
//           if (i === level) {
//             newPath.push("");
//           }
//         } else {
//           break;
//         }
//       }
//       setEditSelectedCategoryPath(newPath);
//     };

//     const showNoSubcategoryOption = currentCategories.length > 0;

//     return (
//       <div key={level} style={styles.inputGroup}>
//         <label style={styles.label}>
//           {level === 0 ? 'Catégorie principale' : `Sous-catégorie niveau ${level}`}
//         </label>
//         <select
//           value={editSelectedCategoryPath[level] || ''}
//           onChange={(e) => handleEditCategoryChange(e.target.value, level)}
//           style={styles.select}
//         >
//           {showNoSubcategoryOption && (
//             <option style={{paddingTop: 8, paddingBottom: 8}} value="">
//               <em>{level === 0 ? 'Sélectionner une catégorie' : 'Pas de sous-catégorie'}</em>
//             </option>
//           )}
//           {currentCategories.map((cat) => (
//             <option key={cat.id} value={cat.id}>{cat.name}</option>
//           ))}
//         </select>
//       </div>
//     );
//   }

//   const handleScheduleChange = (newSchedule) => {
//     setDrinkSchedule(newSchedule);
//   };
 
//   const handleAddCategory = () => {
//     if (currentCategory && !categories.includes(currentCategory)) {
//       setCategories([...categories, currentCategory]);
//       setCurrentCategory('');
//     }
//   };
 
//   // Fonction pour réinitialiser le formulaire
//   const resetForm = () => {
//     setDrinkName('');
//     setDescription('');
//     setPrice('');
//     setDiscount('');
//     setUnitPrice('');
//     setUnitVolume('');
//     setImageFile(null);
//     setSelectedCategoryPath([]);
//     setSelectedCustomCategoryIds([]);
//     setDrinkSchedule([]);
//     setRefusedContainers([]);
//     setProductType('drink');
//     setForGourd(false);
//     setForMug(false);
//     setForBox(false);
//     setBio(false);
//     setIsVegetarian(false);
//     setHasAgreed(false);
//     setSelectedContainerId('');
//     setCanBeOffered(false);
//     setIsVisible(true);
//     setIsEnterpriseCodeRequired(false);
//     setContenantRequired(false);
//     setDepositPrice('');
//     setAcceptsCustomerContainer(false);
//     setPreconditionedWithDeposit(false);
//     setPricingMode('perLiter');
//     SetProduct_category('drink');
//   };
 
//   // Fonctions pour ouvrir/fermer le modal d'ajout
//   const openAddModal = () => {
//     resetForm();
//     setIsAddModalOpen(true);
//   };
 
//   const closeAddModal = () => {
//     setIsAddModalOpen(false);
//     resetForm();
//   };
 
//   const handleSubmit = async (e) => {
//     e.preventDefault();
 
//     if (preconditionedWithDeposit && (isNaN(depositPrice) || depositPrice <= 0)) {
//       alert("Le prix de la caution consigne doit être un nombre positif.");
//       return;
//     }
 
//     const discountNumber = parseFloat(discount);
//     if (isNaN(discountNumber) || discountNumber < 0 || discountNumber > 100) {
//       alert("La réduction doit être un nombre entre 0 et 100.");
//       return;
//     }
 
//     if (!drinkName || !imageFile) {
//       alert("Veuillez fournir un nom et une photo pour la boisson.");
//       return;
//     }
 
//     let isPriceValid = false;
//     if (pricingMode === 'perLiter') {
//       const pricePerMl = parseFloat(price);
//       isPriceValid = !isNaN(pricePerMl) && pricePerMl > 0;
//     } else if (pricingMode === 'perUnit') {
//       const unitPriceValue = parseFloat(unitPrice);
//       isPriceValid = !isNaN(unitPriceValue) && unitPriceValue > 0;
//     }
 
//     // Validation des catégories
//     if (selectedCustomCategoryIds.length === 0) {
//       alert("Veuillez sélectionner au moins une catégorie pour le produit.");
//       return;
//     }
 
//     try {
//       const formData = new FormData();
//       formData.append('establishment_id', id_etablissement);
//       formData.append('discount', discountNumber);
      
//       if ((contenantRequired) && (productType === 'food')) {
//         formData.append('for_gourd', forGourd);
//         formData.append('for_mug', forMug);
//         formData.append('for_box', forBox);
//       } else {
//         formData.append('for_gourd', false);
//         formData.append('for_mug', false);
//         formData.append('for_box', false);
//       }
 
//       if (productType === 'food' && contenantRequired) {
//         formData.append('preconditioned_with_deposit', preconditionedWithDeposit);
//         formData.append('deposit_price', depositPrice);
//         formData.append('accepts_customer_container', acceptsCustomerContainer);
//         formData.append('isVegetarian', isVegetarian);
//       }
 
//       formData.append('EnterpriseCodeRequired', isEnterpriseCodeRequired);
//       formData.append('refused_containers', JSON.stringify(refusedContainers));
//       formData.append('pricing_mode', pricingMode);
//       formData.append('schedule', JSON.stringify(drinkSchedule));
//       formData.append('bio', bio);
//       formData.append('visible', isVisible);
//       formData.append('product_category', product_category);
//       formData.append('drink_name', drinkName);
//       formData.append('description', description);
//       formData.append('container_disposition', hasAgreed);
//       formData.append('container_id', selectedContainerId);
      
//       // Utiliser les catégories multiples
//       formData.append('custom_category_ids', JSON.stringify(selectedCustomCategoryIds));
      
//       formData.append('offered_drinks', offeredDrinks);
//       formData.append('canBeOffered', canBeOffered);
//       formData.append('ingredients', JSON.stringify([]));
 
//       if (!hasAgreed) {
//         formData.append('container_name', containerName);
//         formData.append('container_brand', containerBrand);
//         formData.append('container_volume', containerVolume);
//         if (containerImage) {
//           formData.append('container_image', containerImage);
//         }
//       }
 
//       if (pricingMode === 'perLiter') {
//         formData.append('price_per_ml', price);
//       } else if (pricingMode === 'perUnit') {
//         formData.append('unit_price', unitPrice);
//         formData.append('unit_volume_ml', unitVolume);
//       }
 
//       if (imageFile) {
//         formData.append('image', imageFile);
//       }
 
//       console.log('---------------------------------------------');
//       for (let pair of formData.entries()) {
//         console.log(pair[0] + ': ' + (pair[1].name ? pair[1].name : pair[1]));
//       }
 
//       const response = await axiosInstance.post('/drinks/drink-establishment-links', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
 
//       if (response.status === 201) {
//         alert('Produit ajouté avec succès à l\'établissement!');
//         closeAddModal();
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error('Erreur lors de l\'ajout du produit', error);
//     }
//   };
 
//   const deleteProduct = async (linkId) => {
//     try {
//       const response = await axiosInstance.delete(`/drinks/drink-establishment-links/${linkId}`);
//       if (response.status === 200) {
//         alert('Produit supprimé avec succès !');
//         setProducts(products.filter(product => product.id !== linkId));
//       }
//     } catch (error) {
//       console.error('Erreur lors de la suppression du produit', error);
//     }
//   };
 
//   const openEditModal = (product) => {
//     setSelectedProductForEdit(product);
//     setSelectedProductForEdit2(product);
//     setSelectedProductIngredients(product.ingredients || []);
//     setEditOfferedDrinks(product.drinks_offered || 0);
    
//     // Gestion des catégories multiples
//     const productCategoryIds = product.custom_categories 
//       ? product.custom_categories.map(cat => cat.id) 
//       : [];
//     setEditSelectedCustomCategoryIds(productCategoryIds);
 
//     // Garder l'ancien système pour rétrocompatibilité
//     const categoryPath = product.categories_boisson?.map(cat => cat.id) || [];
//     setEditSelectedCategoryPath(categoryPath);
    
//     setDrinksCanBeOffered(product.drinks_offered || false);
//     setIsEditModalOpen(true);
//   };
 
//   const closeEditModal = () => {
//     setSelectedProductForEdit(null);
//     setSelectedProductForEdit2(null);
//     setIsEditModalOpen(false);
//   };
 
//   const handleEditSubmit = async (updatedProductData) => {
//     const formData = new FormData();
 
//     if (preconditionedWithDeposit && (isNaN(depositPrice) || depositPrice <= 0)) {
//       alert("Le prix de la caution consigne doit être un nombre positif.");
//       return;
//     }
 
//     console.log("updatedProductData : ", updatedProductData);
 
//     formData.append('bio', updatedProductData.bio);
    
//     if (updatedProductData.container_disposition) {
//       formData.append('id_container_gourdefriendly', updatedProductData.id_container_gourdefriendly);
//     }
    
//     formData.append('for_gourde', updatedProductData.for_gourde);
//     formData.append('for_mug', updatedProductData.for_mug);
//     formData.append('for_box', updatedProductData.for_box);
//     formData.append('offered_drinks', editOfferedDrinks);
 
//     if (updatedProductData.product_category === 'food') {
//       formData.append('preconditioned_with_deposit', updatedProductData.preconditioned_with_deposit);
//       formData.append('deposit_price', updatedProductData.deposit_price);
//       formData.append('accepts_customer_container', updatedProductData.accepts_customer_container);
//       formData.append('isVegetarian', updatedProductData.is_vegetarian);
//     }
 
//     formData.append('refused_containers', JSON.stringify(updatedProductData.refused_containers_id));
//     formData.append('hourly', JSON.stringify(updatedProductData.hourly));
//     formData.append('container_disposition', updatedProductData.container_disposition);
//     formData.append('discount', updatedProductData.discount);
 
//     if (pricingMode2 === 'perLiter') {
//       formData.append('price_per_ml', updatedProductData.price_per_ml);
//       formData.append('unit_price', null);
//       formData.append('unit_volume_ml', null);
//     } else if (pricingMode2 === 'perUnit') {
//       formData.append('unit_price', updatedProductData.unit_price);
//       formData.append('unit_volume_ml', updatedProductData.unit_volume_ml);
//       formData.append('price_per_ml', null);
//     }
 
//     // Utiliser les catégories multiples
//     formData.append('custom_category_ids', JSON.stringify(editSelectedCustomCategoryIds));
//     console.log("editSelectedCustomCategoryIds:", editSelectedCustomCategoryIds);
//     console.log("Données envoyées pour les catégories:", JSON.stringify(editSelectedCustomCategoryIds));
    
//     formData.append('name', updatedProductData.name);
//     formData.append('description', updatedProductData.description);
//     formData.append('EnterpriseCodeRequired', updatedProductData.EnterpriseCodeRequired);
//     formData.append('canBeOffered', drinkcCanBeOffered);
 
//     formData.append('ingredients', JSON.stringify([]));
 
//     if (updatedProductData.imageFile) {
//       console.log(updatedProductData.imageFile);
//       formData.append('image', updatedProductData.imageFile);
//     }
 
//     for (let [key, value] of formData.entries()) {
//       console.log(key, " : ", value);
//     }
 
//     console.log(`https://backend.csibon.app/drinks/drink-establishment-links/${updatedProductData.id}`);
 
//     try {
//       const response = await fetch(`https://backend.csibon.app/drinks/drink-establishment-links/${updatedProductData.id}`, {
//         method: 'PUT',
//         headers: {
//           'Authorization': `Bearer `,
//         },
//         body: formData
//       });
 
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
 
//       const data = await response.json();
//       console.log(data);
//       closeEditModal();
//       // window.location.reload();
//     } catch (error) {
//       console.error('Erreur lors de la mise à jour du produit', error);
//     }
//   };
 
//   const filterContainersForSelection = () => {
//     if (selectedProductForEdit?.for_gourde) {
//       return containers.filter(container => container.gourde);
//     } else if (selectedProductForEdit?.for_mug) {
//       return containers.filter(container => container.mug);
//     }
//     return containers;
//   };
 
//   const scheduleString = selectedProductForEdit?.hourly;
//   let scheduleObject = [];
 
//   try {
//     scheduleObject = scheduleString ? JSON.parse(scheduleString) : [];
//   } catch (error) {
//     console.error("Erreur lors de la conversion des données horaires :", error);
//   }
 
//   const toggleVisibility = async (product) => {
//     try {
//       const response = await axiosInstance.put(`drinks/update-visibility/${product.id}`, {
//         visible: !product.visible
//       });
  
//       if (response.status === 200) {
//         // Mettre à jour l'état local immédiatement
//         setProducts(products.map(p => {
//           if (p.id === product.id) {
//             return { ...p, visible: !p.visible };
//           }
//           return p;
//         }));
        
//         // Message de succès optionnel (plus discret)
//         const newVisibilityText = product.visible ? 'masqué' : 'affiché';
//         console.log(`${product.name} est maintenant ${newVisibilityText}.`);
        
//         // Si vous voulez garder l'alerte, utilisez setTimeout pour qu'elle n'interfère pas avec l'UI
//         setTimeout(() => {
//           // Optionnel : notification discrète au lieu d'alert
//           // alert(`${product.name} est maintenant ${newVisibilityText}.`);
//         }, 100);
//       }
//     } catch (error) {
//       console.error('Erreur lors de la modification de la visibilité', error);
//       alert('Erreur lors de la modification de la visibilité');
//     }
//   };
 
//   function renderCategories(categories) {
//     return (
//       <div style={styles.productTags}>
//         {categories.map(category => (
//           <span 
//             key={category.id}
//             style={{...styles.tag, ...styles.tagGreen}}
//           >
//             {category.name}
//           </span>
//         ))}
//       </div>
//     );
//   }
 
//   // Fonctions de filtrage des produits
//   const filterProducts = (productList) => {
//     let filtered = productList;
 
//     // Filtrer par terme de recherche
//     if (searchTerm) {
//       filtered = filtered.filter(product => 
//         product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.description?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
 
//     // Filtrer par catégorie
//     if (filterCategory !== 'all') {
//       if (filterCategory === 'no-category') {
//         filtered = filtered.filter(product => 
//           (!product.custom_categories || product.custom_categories.length === 0) &&
//           (!product.categories_boisson || product.categories_boisson.length === 0)
//         );
//       } else {
//         filtered = filtered.filter(product => 
//           product.custom_categories?.some(cat => cat.id === parseInt(filterCategory)) ||
//           product.categories_boisson?.some(cat => cat.id === parseInt(filterCategory))
//         );
//       }
//     }
 
//     return filtered;
//   };
 
//   // Fonction pour séparer les produits par type
//   const drinkProducts = filterProducts(products.filter(product => product.product_category === 'drink'));
//   const foodProducts = filterProducts(products.filter(product => product.product_category === 'food'));
 
//   // Fonction pour obtenir toutes les catégories utilisées
//   const getAllUsedCategories = () => {
//     const usedCategories = new Set();
    
//     products.forEach(product => {
//       if (product.custom_categories) {
//         product.custom_categories.forEach(cat => usedCategories.add(cat));
//       }
//     });
 
//     return Array.from(usedCategories);
//   };
 
//   // Fonction pour rendre une liste de produits
//   const renderProductList = (productList, emptyMessage, emptyIcon) => {
//     if (productList.length === 0) {
//       return (
//         <div style={styles.emptyState}>
//           <div style={styles.emptyIcon}>{emptyIcon}</div>
//           <div style={styles.emptyTitle}>Aucun produit trouvé</div>
//           <div style={styles.emptyDescription}>{emptyMessage}</div>
//         </div>
//       );
//     }
 
//     return (
//       <div style={styles.productGrid}>
//         {productList.map(product => (
//           <div key={product.id} style={styles.productCard}>
//             {/* Image */}
//             <img
//               src={product.image_url || product.drink?.url_image || '/placeholder.jpg'}
//               alt={product.name}
//               style={styles.productImage}
//             />
 
//             {/* Informations */}
//             <div style={styles.productInfo}>
//               <h3 style={styles.productName}>{product.name}</h3>
//               <p style={styles.productDescription}>{product.description}</p>
              
//               <div style={styles.productTags}>
//                 {product.for_gourde && (
//                   <span style={{...styles.tag, ...styles.tagBlue}}>Gourde</span>
//                 )}
//                 {product.for_mug && (
//                   <span style={{...styles.tag, ...styles.tagBlue}}>Mug</span>
//                 )}
//                 {product.for_box && (
//                   <span style={{...styles.tag, ...styles.tagBlue}}>Box</span>
//                 )}
//                 {product.bio && (
//                   <span style={{...styles.tag, ...styles.tagGreen}}>Bio</span>
//                 )}
//                 {product.is_vegetarian && (
//                   <span style={{...styles.tag, ...styles.tagGreen}}>Végétarien</span>
//                 )}
//                 {product.discount > 0 && (
//                   <span style={{...styles.tag, ...styles.tagRed}}>-{product.discount}%</span>
//                 )}
//                 {!product.visible && (
//                   <span style={{...styles.tag, ...styles.tagRed}}>Masqué</span>
//                 )}
//               </div>
 
//               <div style={{ fontSize: '14px', color: '#64748b' }}>
//                 {product.price_per_ml && (
//                   <div>Prix au litre: {product.price_per_ml}€</div>
//                 )}
//                 {product.unit_price && (
//                   <div>Prix à l'unité: {product.unit_price}€</div>
//                 )}
//                 {product.unit_volume_ml && product.unit_volume_ml != 0 && (
//                   <div>Volume unitaire: {product.unit_volume_ml} ml</div>
//                 )}
//                 <div style={{ 
//                   color: product.discount > 50 ? '#dc2626' : 'inherit',
//                   fontWeight: product.discount > 50 ? '600' : 'normal'
//                 }}>
//                   Réduction: {product.discount ? `${product.discount}%` : 'Aucune'}
//                 </div>
//               </div>
 
//               {product.drinks_offered && (
//                 <div style={{fontSize: '12px', color: '#64748b'}}>
//                   ✓ Cette boisson peut être offerte
//                 </div>
//               )}
 
//               {/* Contenant */}
//               {product.container_disposition && product.container_info && (
//                 <div>
//                   <div style={{...styles.label, marginBottom: '8px'}}>Contenant fourni:</div>
//                   <div style={styles.containerOption}>
//                     {product.container_info.image_url && (
//                       <img 
//                         src={`https://backend.csibon.app/static/container_images/${product.container_info.image_url}`} 
//                         alt={product.container_info.name}
//                         style={styles.containerImage}
//                       />
//                     )}
//                     <div>
//                       <div style={{fontWeight: '500'}}>
//                         {product.container_info.name}
//                       </div>
//                       <div style={{fontSize: '12px', color: '#64748b'}}>
//                         Marque: {product.container_info.brand}
//                         <br />
//                         Volume: {product.container_info.volume}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
 
//               {/* Catégories personnalisées (nouvelles) */}
//               {product.custom_categories && product.custom_categories.length > 0 && (
//                 <div>
//                   <div style={{...styles.label, marginBottom: '8px'}}>Catégories:</div>
//                   {renderCustomCategories(product.custom_categories.map(cat => cat.id))}
//                 </div>
//               )}
 
//               {/* Anciennes catégories (pour rétrocompatibilité) */}
//               {product.categories_boisson && product.categories_boisson.length > 0 && 
//                (!product.custom_categories || product.custom_categories.length === 0) && (
//                 <div>
//                   <div style={{...styles.label, marginBottom: '8px'}}>Catégories (ancien système):</div>
//                   {renderCategories(product.categories_boisson)}
//                 </div>
//               )}
 
//               {/* Options spéciales */}
//               <div style={{fontSize: '12px', color: '#64748b'}}>
//                 {product.EnterpriseCodeRequired && (
//                   <div>🏢 Code entreprise requis</div>
//                 )}
//               </div>
//             </div>
 
//             {/* Actions */}
//             <div style={styles.productActions}>
//               {/* Boutons de réorganisation */}
//               <div style={styles.reorderButtons}>
//                 <button
//                   onClick={() => moveProduct(product.id, 'up')}
//                   style={{
//                     ...styles.reorderButton,
//                     marginBottom: '4px'
//                   }}
//                   title="Déplacer vers le haut"
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#f3f4f6';
//                     e.target.style.borderColor = '#9ca3af';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#ffffff';
//                     e.target.style.borderColor = '#d1d5db';
//                   }}
//                 >
//                   ↑
//                 </button>
//                 <button
//                   onClick={() => moveProduct(product.id, 'down')}
//                   style={styles.reorderButton}
//                   title="Déplacer vers le bas"
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#f3f4f6';
//                     e.target.style.borderColor = '#9ca3af';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#ffffff';
//                     e.target.style.borderColor = '#d1d5db';
//                   }}
//                 >
//                   ↓
//                 </button>
//               </div>
              
//               {/* Actions existantes */}
//               <div style={styles.actionButtons}>
//                 <button
//                   onClick={() => openEditModal(product)}
//                   style={{
//                     ...styles.button,
//                     ...styles.secondaryButton,
//                     fontSize: '14px',
//                     padding: '8px 16px'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#e2e8f0';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#f1f5f9';
//                   }}
//                 >
//                   ✏️ Modifier
//                 </button>
//                 <button
//                   onClick={() => deleteProduct(product.id)}
//                   style={{
//                     ...styles.button,
//                     ...styles.dangerButton,
//                     fontSize: '14px',
//                     padding: '8px 16px'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#b91c1c';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#dc2626';
//                   }}
//                 >
//                   🗑️ Supprimer
//                 </button>
//                 <button
//   onClick={() => toggleVisibility(product)}
//   disabled={updatingVisibility === product.id}
//   style={{
//     ...styles.button,
//     ...(product.visible ? styles.dangerButton : styles.primaryButton),
//     fontSize: '14px',
//     padding: '8px 16px',
//     opacity: updatingVisibility === product.id ? 0.7 : 1
//   }}
// >
//   {updatingVisibility === product.id 
//     ? '⏳ Modification...' 
//     : (product.visible ? '👁️ Masquer' : '👁️ Afficher')
//   }
// </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };
 
//   if (!hasAccess) {
//     return <AccessDeniedMessage />;
//   }
 
//   return (
//     <div style={styles.container}>
//       <AdminNavbar establishmentId={id_etablissement} name={establishment} />
      
//       <button
//         onClick={() => navigate('/accueil')}
//         style={styles.backButton}
//         onMouseEnter={(e) => {
//           e.target.style.backgroundColor = '#e2e8f0';
//         }}
//         onMouseLeave={(e) => {
//           e.target.style.backgroundColor = '#f1f5f9';
//         }}
//       >
//         ← Retour à l'accueil
//       </button>
 
//       <div style={styles.content}>
//         {/* Gestionnaire de catégories personnalisées */}
//         <CategoryManager 
//           establishmentId={id_etablissement}
//           onCategoriesChange={handleCategoriesChange}
//         />
 
//         {/* Header avec bouton d'ajout */}
//         <div style={styles.header}>
//           <div style={styles.headerContent}>
//             <h1 style={styles.title}>Gestion des Produits</h1>
//             <p style={styles.subtitle}>
//               Gérer les produits pour l'établissement {name_etablissement}
//             </p>
//           </div>
//           <button
//             onClick={openAddModal}
//             style={styles.addButton}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = '#047857';
//               e.target.style.transform = 'translateY(-1px)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = '#059669';
//               e.target.style.transform = 'translateY(0)';
//             }}
//           >
//             <span style={{ fontSize: '20px' }}>+</span>
//             Ajouter un produit
//           </button>
//         </div>
 
//         {/* Filtres et recherche */}
//         <div style={styles.section}>
//           <div style={styles.filterSection}>
//             <input
//               type="text"
//               placeholder="Rechercher un produit..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={styles.searchBox}
//             />
//           </div>
//         </div>
 
//         {/* Section Boissons */}
//         <div style={styles.section}>
//           <div style={styles.sectionTitle}>
//             🍹 Boissons ({drinkProducts.length})
//           </div>
//           {renderProductList(
//             drinkProducts, 
//             searchTerm || filterCategory !== 'all' 
//               ? "Aucune boisson ne correspond aux critères de recherche."
//               : "Aucune boisson n'a été ajoutée à cet établissement.",
//             "🍹"
//           )}
//         </div>
 
//         {/* Section Nourriture */}
//         <div style={styles.section}>
//           <div style={styles.sectionTitle}>
//             🍽️ Nourriture ({foodProducts.length})
//           </div>
//           {renderProductList(
//             foodProducts, 
//             searchTerm || filterCategory !== 'all'
//               ? "Aucun produit alimentaire ne correspond aux critères de recherche."
//               : "Aucun produit alimentaire n'a été ajouté à cet établissement.",
//             "🍽️"
//           )}
//         </div>
//       </div>
 
//       {/* Modal d'ajout de produit */}
//       {isAddModalOpen && (
//         <div style={styles.modal} onClick={closeAddModal}>
//           <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//             <h2 style={styles.modalTitle}>Ajouter un nouveau produit</h2>
            
//             <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
              
//               {/* Type de produit */}
//               <div>
//                 <div style={styles.sectionTitleSmall}>
//                   🎯 Type de produit
//                 </div>
//                 <div style={styles.toggleSection}>
//                   <span style={{
//                     fontWeight: productType === 'drink' ? '600' : '400',
//                     color: productType === 'drink' ? '#059669' : '#64748b'
//                   }}>
//                     Boisson
//                   </span>
//                   <button
//                     type="button"
//                     style={{
//                       ...styles.toggleButton,
//                       ...(productType === 'food' ? styles.toggleButtonActive : {})
//                     }}
//                     onClick={() => setProductType(productType === 'drink' ? 'food' : 'drink')}
//                   >
//                     <div style={{
//                       ...styles.toggleThumb,
//                       ...(productType === 'food' ? styles.toggleThumbActive : {})
//                     }}></div>
//                   </button>
//                   <span style={{
//                     fontWeight: productType === 'food' ? '600' : '400',
//                     color: productType === 'food' ? '#059669' : '#64748b'
//                   }}>
//                     Nourriture
//                   </span>
//                 </div>
//               </div>
 
//               {/* Options d'accès */}
//               <div>
//                 <div style={styles.sectionTitleSmall}>
//                   🔐 Options d'accès
//                 </div>
//                 <label style={styles.checkbox}>
//                   <input
//                     type="checkbox"
//                     checked={isEnterpriseCodeRequired}
//                     onChange={(e) => setIsEnterpriseCodeRequired(e.target.checked)}
//                     style={styles.checkboxInput}
//                   />
//                   Disponible uniquement pour les utilisateurs avec code entreprise
//                 </label>
 
//                 {productType === 'food' && (
//                   <label style={styles.checkbox}>
//                     <input
//                       type="checkbox"
//                       checked={contenantRequired}
//                       onChange={(e) => setContenantRequired(e.target.checked)}
//                       style={styles.checkboxInput}
//                     />
//                     Contenant requis
//                   </label>
//                 )}
//               </div>
 
//               {/* Options de contenant pour nourriture */}
//               {productType === 'food' && contenantRequired && (
//                 <div>
//                   <div style={styles.sectionTitleSmall}>
//                     📦 Options de Contenant
//                   </div>
                  
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Prix de la caution consigne (€)</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       value={depositPrice}
//                      onChange={(e) => setDepositPrice(e.target.value)}
//                      style={styles.input}
//                      placeholder="0.00"
//                    />
//                  </div>

//                  <label style={styles.checkbox}>
//                    <input
//                      type="checkbox"
//                      checked={acceptsCustomerContainer}
//                      onChange={(e) => setAcceptsCustomerContainer(e.target.checked)}
//                      style={styles.checkboxInput}
//                    />
//                    Accepte contenant du client
//                  </label>
//                </div>
//              )}

//              {/* Informations de base */}
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  📝 Informations de base
//                </div>
               
//                <div style={styles.inputGroup}>
//                  <label style={styles.label}>Nom du produit *</label>
//                  <input
//                    type="text"
//                    value={drinkName}
//                    onChange={(e) => setDrinkName(e.target.value)}
//                    style={styles.input}
//                    placeholder="Entrez le nom du produit"
//                    onFocus={(e) => {
//                      e.target.style.borderColor = '#059669';
//                      e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
//                    }}
//                    onBlur={(e) => {
//                      e.target.style.borderColor = '#d1d5db';
//                      e.target.style.boxShadow = 'none';
//                    }}
//                  />
//                </div>

//                <div style={styles.inputGroup}>
//                  <label style={styles.label}>Description</label>
//                  <textarea
//                    value={description}
//                    onChange={(e) => setDescription(e.target.value)}
//                    style={styles.textarea}
//                    placeholder="Décrivez votre produit..."
//                    onFocus={(e) => {
//                      e.target.style.borderColor = '#059669';
//                      e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
//                    }}
//                    onBlur={(e) => {
//                      e.target.style.borderColor = '#d1d5db';
//                      e.target.style.boxShadow = 'none';
//                    }}
//                  />
//                </div>

//                {productType === 'food' && (
//                  <label style={styles.checkbox}>
//                    <input
//                      type="checkbox"
//                      checked={isVegetarian}
//                      onChange={(e) => setIsVegetarian(e.target.checked)}
//                      style={styles.checkboxInput}
//                    />
//                    Produit végétarien
//                  </label>
//                )}
//              </div>

//              {/* Catégories personnalisées multiples */}
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  📂 Catégories
//                </div>
//                <CategorySelectorMultiple
//                  establishmentId={id_etablissement}
//                  selectedCategoryIds={selectedCustomCategoryIds}
//                  onCategoriesChange={setSelectedCustomCategoryIds}
//                  label="Sélectionner des catégories *"
//                />
//                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
//                  Vous pouvez sélectionner plusieurs catégories, y compris des catégories de niveaux différents
//                </div>
//              </div>

//              {/* Contenant */}
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  🥤 Fourniture de contenant
//                </div>
               
//                <label style={styles.checkbox}>
//                  <input
//                    type="checkbox"
//                    checked={hasAgreed}
//                    onChange={(e) => setHasAgreed(e.target.checked)}
//                    style={styles.checkboxInput}
//                  />
//                  Je m'engage à fournir un contenant
//                </label>

//                {hasAgreed && (
//                  <div style={styles.inputGroup}>
//                  <label style={styles.label}>Contenant</label>
//                  <select
//                    value={selectedContainerId}
//                    onChange={(e) => setSelectedContainerId(e.target.value)}
//                    style={styles.select}
//                  >
//                    <option value="">Choisissez un contenant...</option>
//                    {containers_chr.map((container) => (
//                      <option key={container.id} value={container.id}>
//                        {container.name} ({container.brand})
//                      </option>
//                    ))}
//                  </select>
//                </div>
//              )}
//            </div>

//            {/* Type de contenant pour boissons */}
//            {productType === 'drink' && (
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  🍹 Type de contenant
//                </div>
               
//                <label style={styles.checkbox}>
//                  <input
//                    type="checkbox"
//                    checked={forGourd}
//                    onChange={(e) => setForGourd(e.target.checked)}
//                    style={styles.checkboxInput}
//                  />
//                  Pour Gourde
//                </label>
               
//                <label style={styles.checkbox}>
//                  <input
//                    type="checkbox"
//                    checked={forMug}
//                    onChange={(e) => setForMug(e.target.checked)}
//                    style={styles.checkboxInput}
//                  />
//                  Pour Mug
//                </label>

//                <label style={styles.checkbox}>
//                  <input
//                    type="checkbox"
//                    checked={bio}
//                    onChange={(e) => setBio(e.target.checked)}
//                    style={styles.checkboxInput}
//                  />
//                  Boisson bio
//                </label>
//              </div>
//            )}

//            {/* Horaires */}
//            <div>
//              <div style={styles.sectionTitleSmall}>
//                🕒 Horaires de disponibilité
//              </div>
//              <DrinkSchedule onScheduleChange={handleScheduleChange} />
//            </div>

//            {/* Prix */}
//            {productType === 'drink' && (
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  💰 Tarification
//                </div>
               
//                <div style={styles.radioGroup}>
//                  <label style={{
//                    ...styles.radioOption,
//                    ...(pricingMode === 'perLiter' ? styles.radioOptionSelected : {})
//                  }}>
//                    <input
//                      type="radio"
//                      name="pricingMode"
//                      value="perLiter"
//                      checked={pricingMode === 'perLiter'}
//                      onChange={(e) => setPricingMode(e.target.value)}
//                      style={styles.checkboxInput}
//                    />
//                    Prix au litre
//                  </label>
//                  <label style={{
//                    ...styles.radioOption,
//                    ...(pricingMode === 'perUnit' ? styles.radioOptionSelected : {})
//                  }}>
//                    <input
//                      type="radio"
//                      name="pricingMode"
//                      value="perUnit"
//                      checked={pricingMode === 'perUnit'}
//                      onChange={(e) => setPricingMode(e.target.value)}
//                      style={styles.checkboxInput}
//                    />
//                    Prix à l'unité
//                  </label>
//                </div>

//                {pricingMode === 'perLiter' && (
//                  <div style={styles.inputGroup}>
//                    <label style={styles.label}>Prix au litre (€)</label>
//                    <input
//                      type="number"
//                      step="0.01"
//                      value={price}
//                      onChange={(e) => setPrice(e.target.value)}
//                      style={styles.input}
//                      placeholder="0.00"
//                    />
//                  </div>
//                )}

//                {pricingMode === 'perUnit' && (
//                  <>
//                    <div style={styles.inputGroup}>
//                      <label style={styles.label}>Prix à l'unité (€)</label>
//                      <input
//                        type="number"
//                        step="0.01"
//                        value={unitPrice}
//                        onChange={(e) => setUnitPrice(e.target.value)}
//                        style={styles.input}
//                        placeholder="0.00"
//                      />
//                    </div>
//                    <div style={styles.inputGroup}>
//                      <label style={styles.label}>Volume par unité (cl)</label>
//                      <input
//                        type="number"
//                        value={unitVolume}
//                        onChange={(e) => setUnitVolume(e.target.value)}
//                        style={styles.input}
//                        placeholder="25"
//                      />
//                    </div>
//                  </>
//                )}
//              </div>
//            )}

//            {productType === 'food' && (
//              <div>
//                <div style={styles.sectionTitleSmall}>
//                  💰 Prix
//                </div>
//                <div style={styles.inputGroup}>
//                  <label style={styles.label}>Prix (€)</label>
//                  <input
//                    type="number"
//                    step="0.01"
//                    value={unitPrice}
//                    onChange={(e) => setUnitPrice(e.target.value)}
//                    style={styles.input}
//                    placeholder="0.00"
//                  />
//                </div>
//              </div>
//            )}

//            {/* Réduction */}
//            <div>
//              <div style={styles.sectionTitleSmall}>
//                🏷️ Réduction
//              </div>
//              <div style={styles.inputGroup}>
//                <label style={styles.label}>Réduction (%)</label>
//                <input
//                  type="number"
//                  min="0"
//                  max="100"
//                  value={discount}
//                  onChange={(e) => setDiscount(e.target.value)}
//                  style={{
//                    ...styles.input,
//                    borderColor: (discount < 0 || discount > 100) ? '#dc2626' : '#d1d5db'
//                  }}
//                  placeholder="0"
//                />
//                {(discount < 0 || discount > 100) && (
//                  <span style={{ color: '#dc2626', fontSize: '14px' }}>
//                    La réduction doit être entre 0 et 100%
//                  </span>
//                )}
//              </div>
//            </div>

//            {/* Image */}
//            <div>
//              <div style={styles.sectionTitleSmall}>
//                📸 Image du produit
//              </div>
//              <div style={styles.inputGroup}>
//                <label style={styles.label}>Choisir une image *</label>
//                <input
//                  type="file"
//                  accept="image/*"
//                  onChange={(e) => setImageFile(e.target.files[0])}
//                  style={styles.input}
//                />
//              </div>
//            </div>

//            {/* Options de visibilité */}
//            <div>
//              <div style={styles.sectionTitleSmall}>
//                👁️ Visibilité et offres
//              </div>
             
//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={canBeOffered}
//                  onChange={(e) => setCanBeOffered(e.target.checked)}
//                  style={styles.checkboxInput}
//                />
//                Produit peut être offert
//              </label>

//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={isVisible}
//                  onChange={(e) => setIsVisible(e.target.checked)}
//                  style={styles.checkboxInput}
//                />
//                Produit visible dans l'application
//              </label>
//            </div>

//            {/* Actions du modal */}
//            <div style={styles.modalActions}>
//              <button
//                type="button"
//                onClick={closeAddModal}
//                style={{
//                  ...styles.button,
//                  ...styles.secondaryButton
//                }}
//                onMouseEnter={(e) => {
//                  e.target.style.backgroundColor = '#e2e8f0';
//                }}
//                onMouseLeave={(e) => {
//                  e.target.style.backgroundColor = '#f1f5f9';
//                }}
//              >
//                Annuler
//              </button>
//              <button
//                type="submit"
//                style={{
//                  ...styles.button,
//                  ...styles.primaryButton
//                }}
//                onMouseEnter={(e) => {
//                  e.target.style.backgroundColor = '#047857';
//                }}
//                onMouseLeave={(e) => {
//                  e.target.style.backgroundColor = '#059669';
//                }}
//              >
//                ➕ Ajouter le produit
//              </button>
//            </div>
//          </form>
//        </div>
//      </div>
//    )}

//    {/* Modal de modification */}
//    {isEditModalOpen && (
//      <div style={styles.modal} onClick={closeEditModal}>
//        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//          <h2 style={styles.modalTitle}>Modifier le produit</h2>
         
//          {/* Code entreprise requis */}
//          <label style={styles.checkbox}>
//            <input
//              type="checkbox"
//              checked={selectedProductForEdit?.EnterpriseCodeRequired || false}
//              onChange={(e) => setSelectedProductForEdit({ 
//                ...selectedProductForEdit, 
//                EnterpriseCodeRequired: e.target.checked 
//              })}
//              style={styles.checkboxInput}
//            />
//            Disponible uniquement pour les utilisateurs avec code entreprise
//          </label>

//          {/* Végétarien pour nourriture */}
//          {selectedProductForEdit?.product_category === 'food' && (
//            <>
//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={selectedProductForEdit?.is_vegetarian || false}
//                  onChange={(e) => setSelectedProductForEdit({ 
//                    ...selectedProductForEdit, 
//                    is_vegetarian: e.target.checked 
//                  })}
//                  style={styles.checkboxInput}
//                />
//                Produit végétarien
//              </label>

//              {/* Options de contenant pour nourriture */}
//              <div style={styles.inputGroup}>
//                <label style={styles.label}>Prix de la caution consigne (€)</label>
//                <input
//                  type="number"
//                  step="0.01"
//                  value={selectedProductForEdit.deposit_price || ''}
//                  onChange={(e) => setSelectedProductForEdit({ 
//                    ...selectedProductForEdit, 
//                    deposit_price: e.target.value 
//                  })}
//                  style={styles.input}
//                />
//              </div>

//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={selectedProductForEdit.accepts_customer_container || false}
//                  onChange={(e) => setSelectedProductForEdit({ 
//                    ...selectedProductForEdit, 
//                    accepts_customer_container: e.target.checked 
//                  })}
//                  style={styles.checkboxInput}
//                />
//                Accepte contenant du client
//              </label>
//            </>
//          )}

//          {/* Nom */}
//          <div style={styles.inputGroup}>
//            <label style={styles.label}>Nom du produit</label>
//            <input
//              type="text"
//              value={selectedProductForEdit?.name || ''}
//              onChange={(e) => setSelectedProductForEdit({
//                ...selectedProductForEdit,
//                name: e.target.value
//              })}
//              style={styles.input}
//            />
//          </div>

//          {/* Description */}
//          <div style={styles.inputGroup}>
//            <label style={styles.label}>Description</label>
//            <textarea
//              value={selectedProductForEdit?.description || ''}
//              onChange={(e) => setSelectedProductForEdit({
//                ...selectedProductForEdit,
//                description: e.target.value
//              })}
//              style={styles.textarea}
//            />
//          </div>

//          {/* Catégories personnalisées multiples */}
//          <div>
//            <label style={styles.label}>Catégories</label>
//            <CategorySelectorMultiple
//              establishmentId={id_etablissement}
//              selectedCategoryIds={editSelectedCustomCategoryIds}
//              onCategoriesChange={setEditSelectedCustomCategoryIds}
//              label="Sélectionner des catégories"
//            />
//          </div>

//          {/* Bio pour boissons */}
//          {selectedProductForEdit?.product_category === 'drink' && (
//            <label style={styles.checkbox}>
//              <input
//                type="checkbox"
//                checked={selectedProductForEdit?.bio || false}
//                onChange={(e) => setSelectedProductForEdit({ 
//                  ...selectedProductForEdit, 
//                  bio: e.target.checked 
//                })}
//                style={styles.checkboxInput}
//              />
//              Produit bio
//            </label>
//          )}

//          {/* Remise de contenant */}
//          <label style={styles.checkbox}>
//            <input
//              type="checkbox"
//              checked={selectedProductForEdit?.container_disposition || false}
//              onChange={(e) => setSelectedProductForEdit({ 
//                ...selectedProductForEdit, 
//                container_disposition: e.target.checked 
//              })}
//              style={styles.checkboxInput}
//            />
//            Remise d'un contenant
//          </label>

//          {/* Sélection du contenant */}
//          {selectedProductForEdit?.container_disposition && (
//            <div style={styles.inputGroup}>
//              <label style={styles.label}>Contenant</label>
//              <select
//                value={selectedProductForEdit?.id_container_gourdefriendly || ''}
//                onChange={(e) => setSelectedProductForEdit({
//                  ...selectedProductForEdit,
//                  id_container_gourdefriendly: e.target.value
//                })}
//                style={styles.select}
//              >
//                <option value="">Choisissez un contenant...</option>
//                {containers_chr.map((container) => (
//                  <option key={container.id} value={container.id}>
//                    {container.name} ({container.brand})
//                  </option>
//                ))}
//              </select>
//            </div>
//          )}

//          {/* Type de contenant pour boissons */}
//          {selectedProductForEdit?.product_category === 'drink' && (
//            <>
//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={selectedProductForEdit?.for_gourde || false}
//                  onChange={(e) => setSelectedProductForEdit({ 
//                    ...selectedProductForEdit, 
//                    for_gourde: e.target.checked 
//                  })}
//                  style={styles.checkboxInput}
//                />
//                Pour Gourde
//              </label>
             
//              <label style={styles.checkbox}>
//                <input
//                  type="checkbox"
//                  checked={selectedProductForEdit?.for_mug || false}
//                  onChange={(e) => setSelectedProductForEdit({ 
//                    ...selectedProductForEdit, 
//                    for_mug: e.target.checked 
//                  })}
//                  style={styles.checkboxInput}
//                />
//                Pour Mug
//              </label>
//            </>
//          )}

//          {/* Horaires */}
//          <div>
//            <label style={styles.label}>Horaires de disponibilité</label>
//            <DrinkSchedule
//              schedule={scheduleObject}
//              onScheduleChange={(newSchedule) =>
//                setSelectedProductForEdit({ 
//                  ...selectedProductForEdit, 
//                  hourly: JSON.stringify(newSchedule) 
//                })
//              }
//            />
//          </div>

//          {/* Peut être offert */}
//          <label style={styles.checkbox}>
//            <input
//              type="checkbox"
//              checked={drinkcCanBeOffered}
//              onChange={(e) => setDrinksCanBeOffered(e.target.checked)}
//              style={styles.checkboxInput}
//            />
//            Produit peut être offert
//          </label>

//          {/* Contenants refusés */}
//          <div style={styles.inputGroup}>
//            <label style={styles.label}>Contenants refusés</label>
//            <select
//              multiple
//              value={selectedProductForEdit?.refused_containers_id || []}
//              onChange={(e) => setSelectedProductForEdit({
//                ...selectedProductForEdit,
//                refused_containers_id: [...e.target.selectedOptions].map(o => o.value)
//              })}
//              style={{...styles.select, minHeight: '120px'}}
//            >
//              {filterContainersForSelection().map(container => (
//                <option key={container.id} value={container.id}>
//                  {container.name} ({container.brand})
//                </option>
//              ))}
//            </select>
//          </div>

//          {/* Tarification pour boissons */}
//          {selectedProductForEdit?.product_category === 'drink' && (
//            <>
//              <div>
//                <label style={styles.label}>Mode de tarification</label>
//                <div style={styles.radioGroup}>
//                  <label style={{
//                    ...styles.radioOption,
//                    ...(pricingMode2 === 'perLiter' ? styles.radioOptionSelected : {})
//                  }}>
//                    <input
//                      type="radio"
//                      name="pricingMode2"
//                      value="perLiter"
//                      checked={pricingMode2 === 'perLiter'}
//                      onChange={(e) => setPricingMode2(e.target.value)}
//                      style={styles.checkboxInput}
//                    />
//                    Prix au litre
//                  </label>
//                  <label style={{
//                    ...styles.radioOption,
//                    ...(pricingMode2 === 'perUnit' ? styles.radioOptionSelected : {})
//                  }}>
//                    <input
//                      type="radio"
//                      name="pricingMode2"
//                      value="perUnit"
//                      checked={pricingMode2 === 'perUnit'}
//                      onChange={(e) => setPricingMode2(e.target.value)}
//                      style={styles.checkboxInput}
//                    />
//                    Prix à l'unité
//                  </label>
//                </div>
//              </div>

//              {pricingMode2 === 'perLiter' && (
//                <div style={styles.inputGroup}>
//                  <label style={styles.label}>Prix au litre (€)</label>
//                  <input
//                    type="number"
//                    step="0.01"
//                    value={selectedProductForEdit?.price_per_ml || ''}
//                    onChange={(e) => setSelectedProductForEdit({
//                      ...selectedProductForEdit,
//                      price_per_ml: e.target.value
//                    })}
//                    style={styles.input}
//                  />
//                </div>
//              )}

//              {pricingMode2 === 'perUnit' && (
//                <>
//                  <div style={styles.inputGroup}>
//                    <label style={styles.label}>Prix à l'unité (€)</label>
//                    <input
//                      type="number"
//                      step="0.01"
//                      value={selectedProductForEdit?.unit_price || ''}
//                      onChange={(e) => setSelectedProductForEdit({
//                        ...selectedProductForEdit,
//                        unit_price: e.target.value
//                      })}
//                      style={styles.input}
//                    />
//                  </div>
//                  <div style={styles.inputGroup}>
//                    <label style={styles.label}>Volume par unité (cl)</label>
//                    <input
//                      type="number"
//                      value={selectedProductForEdit?.unit_volume_ml || ''}
//                      onChange={(e) => setSelectedProductForEdit({
//                        ...selectedProductForEdit,
//                        unit_volume_ml: e.target.value
//                      })}
//                      style={styles.input}
//                    />
//                  </div>
//                </>
//              )}
//            </>
//          )}

//          {/* Prix pour nourriture */}
//          {selectedProductForEdit?.product_category === 'food' && (
//            <div style={styles.inputGroup}>
//              <label style={styles.label}>Prix (€)</label>
//              <input
//                type="number"
//                step="0.01"
//                value={selectedProductForEdit?.unit_price || ''}
//                onChange={(e) => setSelectedProductForEdit({
//                  ...selectedProductForEdit,
//                  unit_price: e.target.value
//                })}
//                style={styles.input}
//              />
//            </div>
//          )}

//          {/* Réduction */}
//          <div style={styles.inputGroup}>
//            <label style={styles.label}>Réduction (%)</label>
//            <input
//              type="number"
//              min="0"
//              max="100"
//              value={selectedProductForEdit?.discount || ''}
//              onChange={(e) => setSelectedProductForEdit({
//                ...selectedProductForEdit,
//                discount: e.target.value
//              })}
//              style={{
//                ...styles.input,
//                borderColor: (selectedProductForEdit?.discount < 0 || selectedProductForEdit?.discount > 100) ? '#dc2626' : '#d1d5db'
//              }}
//            />
//            {(selectedProductForEdit?.discount < 0 || selectedProductForEdit?.discount > 100) && (
//              <span style={{ color: '#dc2626', fontSize: '14px' }}>
//                La réduction doit être entre 0 et 100%
//              </span>
//            )}
//          </div>

//          {/* Nouvelle image */}
//          <div style={styles.inputGroup}>
//            <label style={styles.label}>Nouvelle image</label>
//            <input
//              type="file"
//              accept="image/*"
//              onChange={(e) => setSelectedProductForEdit({
//                ...selectedProductForEdit,
//                imageFile: e.target.files[0]
//              })}
//              style={styles.input}
//            />
//            {selectedProductForEdit?.imageFile && (
//              <img
//                src={URL.createObjectURL(selectedProductForEdit.imageFile)}
//                alt="Aperçu"
//                style={{
//                  width: '120px',
//                  height: '90px',
//                  objectFit: 'cover',
//                  borderRadius: '8px',
//                  marginTop: '8px'
//                }}
//              />
//            )}
//          </div>

//          {/* Actions du modal */}
//          <div style={styles.modalActions}>
//            <button
//              onClick={closeEditModal}
//              style={{
//                ...styles.button,
//                ...styles.secondaryButton
//              }}
//              onMouseEnter={(e) => {
//                e.target.style.backgroundColor = '#e2e8f0';
//              }}
//              onMouseLeave={(e) => {
//                e.target.style.backgroundColor = '#f1f5f9';
//              }}
//            >
//              Annuler
//            </button>
//            <button
//              onClick={() => handleEditSubmit(selectedProductForEdit)}
//              style={{
//                ...styles.button,
//                ...styles.primaryButton
//              }}
//              onMouseEnter={(e) => {
//                e.target.style.backgroundColor = '#047857';
//              }}
//              onMouseLeave={(e) => {
//                e.target.style.backgroundColor = '#059669';
//              }}
//            >
//              Enregistrer les modifications
//            </button>
//          </div>
//        </div>
//      </div>
//    )}
//  </div>
// );
// }

// export default ManageProductsPage;






import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminNavbar from '../../components/AdminNavbar';
import axiosInstance from '../../services/axiosInstance';
import AccessDeniedMessage from '../../components/AccessDeniedMessage';
import DrinkSchedule from '../../components/DrinkSchedule';
import CreateContainerComponent from '../../components/CreateContainerComponentEtablissement';
import CategoryManager from '../../components/CategoryManager';
import CategorySelectorMultiple from '../../components/CategorySelectorMultiple';

async function fetchEstablishment(id) {
  try {
    const res = await axiosInstance.get(`/establishments/${id}`);
    return res.data.establishment;
  } catch (err) {
    if (err.response && err.response.data && err.response.data.error) {
      return false;
    } else {
      alert("Une erreur est survenue lors de la récupération de l'établissement.");
    }
    console.error(err);
    return null;
  }
}

function ManageProductsPage() {
  const { id_etablissement } = useParams();
  const navigate = useNavigate();
  
  // États existants conservés
  const [establishment, setEstablishment] = useState(null);
  const [products, setProducts] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [selectedDrinkId, setSelectedDrinkId] = useState(null);
  const [price, setPrice] = useState('');
  const [discount, setDiscount] = useState('');
  const [name_etablissement, SetNameEtablissement] = useState('');
  const [product_category, SetProduct_category] = useState('drink');
  const [forGourd, setForGourd] = useState(false);
  const [forMug, setForMug] = useState(false);
  const [forBox, setForBox] = useState(false);
  const [refusedContainers, setRefusedContainers] = useState([]);
  const [containers, setContainers] = useState([]);
  const [containers_chr, setContainers_chr] = useState([]);
  const [unitPrice, setUnitPrice] = useState('');
  const [unitPricePickup, setUnitPricePickup] = useState('');
  const [unitPriceDelivery, setUnitPriceDelivery] = useState('');
  const [serviceMode, setServiceMode] = useState('pickup');
  const [pricingMode, setPricingMode] = useState('perLiter');
  const [pricingMode2, setPricingMode2] = useState('perLiter');
  const [unitVolume, setUnitVolume] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [hasAccess, sethasAccess] = useState(true);
  const [bio, setBio] = useState(false);
  const [filteredContainers, setFilteredContainers] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [drinkName, setDrinkName] = useState('');
  const [description, setDescription] = useState('');
  const [category_boisson, setCategory_boisson] = useState('');
  const [selectedContainerId, setSelectedContainerId] = useState('');
  const [selectedContainerId2, setSelectedContainerId2] = useState('');
  const [currentCategory, setCurrentCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [drinkSchedule, setDrinkSchedule] = useState([]);
  const [isEnterpriseCodeRequired, setIsEnterpriseCodeRequired] = useState(false);
  const [contenantRequired, setContenantRequired] = useState(false);
  const [hasAgreed, setHasAgreed] = useState(false);
  const [containerName, setContainerName] = useState('');
  const [containerBrand, setContainerBrand] = useState('');
  const [containerVolume, setContainerVolume] = useState('');
  const [containerImage, setContainerImage] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProductForEdit, setSelectedProductForEdit] = useState(null);
  const [selectedProductForEdit2, setSelectedProductForEdit2] = useState(null);
  const [categories_boisson, setCategories_boisson] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedProductIngredients, setSelectedProductIngredients] = useState([]);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [selectedCategoryPath, setSelectedCategoryPath] = useState([]);
  const [categories_easydrinks, setCategories_easydrinks] = useState([]);
  const [editSelectedCategoryPath, setEditSelectedCategoryPath] = useState([]);
  const [productType, setProductType] = useState('drink');
  const [editOfferedDrinks, setEditOfferedDrinks] = useState(0);
  const [offeredDrinks, setOfferedDrinks] = useState(0);
  const [canBeOffered, setCanBeOffered] = useState(false);
  const [drinkcCanBeOffered, setDrinksCanBeOffered] = useState(false);
  const [depositPrice, setDepositPrice] = useState('');
  const [acceptsCustomerContainer, setAcceptsCustomerContainer] = useState(false);
  const [preconditionedWithDeposit, setPreconditionedWithDeposit] = useState(false);
  const [isVegetarian, setIsVegetarian] = useState(false);
  const [isContainerModalOpen, setIsContainerModalOpen] = useState(false);

  // Nouveaux états pour les catégories personnalisées multiples
  const [customCategories, setCustomCategories] = useState([]);
  const [selectedCustomCategoryIds, setSelectedCustomCategoryIds] = useState([]);
  const [editSelectedCustomCategoryIds, setEditSelectedCustomCategoryIds] = useState([]);

  // Nouveau état pour le modal d'ajout
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // État pour le filtre des produits
  const [filterCategory, setFilterCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const [updatingVisibility, setUpdatingVisibility] = useState(null);

  // État d'édition pour les horaires
  const [editSchedule, setEditSchedule] = useState([]);

  // Styles modernisés
  const styles = {
    container: {
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    backButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 20px',
      margin: '20px',
      backgroundColor: '#f1f5f9',
      color: '#475569',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      textDecoration: 'none',
      transition: 'all 0.2s ease-in-out'
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '32px'
    },
    header: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '32px',
      marginBottom: '32px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: '1px solid #e2e8f0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    headerContent: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#1e293b',
      margin: '0 0 8px 0'
    },
    subtitle: {
      fontSize: '16px',
      color: '#64748b',
      margin: 0
    },
    addButton: {
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      padding: '16px 24px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s ease-in-out',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    section: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: '1px solid #e2e8f0',
      marginBottom: '24px'
    },
    sectionTitle: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    sectionTitleSmall: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    filterSection: {
      display: 'flex',
      gap: '16px',
      marginBottom: '24px',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    searchBox: {
      flex: 1,
      minWidth: '200px',
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '14px'
    },
    filterButtons: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap'
    },
    filterButton: {
      padding: '8px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease-in-out'
    },
    filterButtonActive: {
      backgroundColor: '#059669',
      color: '#ffffff',
      borderColor: '#059669'
    },
    toggleSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      padding: '16px',
      backgroundColor: '#f8fafc',
      borderRadius: '8px',
      border: '2px solid #e2e8f0'
    },
    toggleButton: {
      position: 'relative',
      width: '60px',
      height: '32px',
      backgroundColor: '#cbd5e1',
      borderRadius: '16px',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out'
    },
    toggleButtonActive: {
      backgroundColor: '#059669'
    },
    toggleThumb: {
      position: 'absolute',
      top: '2px',
      left: '2px',
      width: '28px',
      height: '28px',
      backgroundColor: '#ffffff',
      borderRadius: '50%',
      transition: 'transform 0.2s ease-in-out',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    toggleThumbActive: {
      transform: 'translateX(28px)'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      marginBottom: '16px'
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151'
    },
    input: {
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '16px',
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      outline: 'none',
      backgroundColor: '#ffffff'
    },
    textarea: {
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '16px',
      minHeight: '120px',
      resize: 'vertical',
      fontFamily: 'inherit',
      outline: 'none'
    },
    select: {
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '16px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      outline: 'none'
    },
    checkbox: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px',
      backgroundColor: '#f8fafc',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      cursor: 'pointer',
      marginBottom: '8px'
    },
    checkboxInput: {
      width: '18px',
      height: '18px',
      accentColor: '#059669'
    },
    radioGroup: {
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      marginBottom: '16px'
    },
    radioOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      backgroundColor: '#f8fafc',
      border: '2px solid #e2e8f0',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out'
    },
    radioOptionSelected: {
      backgroundColor: '#dcfdf7',
      borderColor: '#059669'
    },
    button: {
      padding: '12px 24px',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px'
    },
    primaryButton: {
      backgroundColor: '#059669',
      color: '#ffffff'
    },
    secondaryButton: {
      backgroundColor: '#f1f5f9',
      color: '#475569'
    },
    dangerButton: {
      backgroundColor: '#dc2626',
      color: '#ffffff'
    },
    productGrid: {
      display: 'grid',
      gap: '24px'
    },
    productCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '24px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: '1px solid #e2e8f0',
      display: 'grid',
      gridTemplateColumns: '200px 1fr auto',
      gap: '24px',
      alignItems: 'start'
    },
    productImage: {
      width: '200px',
      height: '150px',
      objectFit: 'cover',
      borderRadius: '12px'
    },
    productInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    productName: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#1e293b',
      margin: 0
    },
    productDescription: {
      fontSize: '14px',
      color: '#64748b',
      lineHeight: '1.5'
    },
    productTags: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px'
    },
    tag: {
      padding: '4px 12px',
      backgroundColor: '#f1f5f9',
      color: '#475569',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '500'
    },
    tagGreen: {
      backgroundColor: '#dcfdf7',
      color: '#059669'
    },
    tagRed: {
      backgroundColor: '#fef2f2',
      color: '#dc2626'
    },
    tagBlue: {
      backgroundColor: '#dbeafe',
      color: '#2563eb'
    },
    productActions: {
      display: 'flex',
      gap: '12px',
      minWidth: '180px',
      alignItems: 'flex-start'
    },
    reorderButtons: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px'
    },
    reorderButton: {
      width: '30px',
      height: '30px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      color: '#374151',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s ease-in-out'
    },
    actionButtons: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      flex: 1
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '32px',
      width: '100%',
      maxWidth: '900px',
      maxHeight: '90vh',
      overflow: 'auto'
    },
    modalTitle: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#1e293b',
      marginBottom: '24px'
    },
    modalActions: {
      display: 'flex',
      gap: '12px',
      marginTop: '32px',
      justifyContent: 'flex-end'
    },
    containerOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      marginBottom: '8px'
    },
    containerImage: {
      width: '40px',
      height: '40px',
      objectFit: 'cover',
      borderRadius: '4px'
    },
    emptyState: {
      textAlign: 'center',
      padding: '40px',
      color: '#64748b'
    },
    emptyIcon: {
      fontSize: '48px',
      marginBottom: '16px'
    },
    emptyTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px'
    },
    emptyDescription: {
      fontSize: '14px',
      color: '#6b7280'
    },
    categoryFilters: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '12px'
    },
    categoryFilterButton: {
      padding: '6px 12px',
      border: '1px solid #e2e8f0',
      borderRadius: '16px',
      fontSize: '12px',
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s ease-in-out'
    }
  };

  // Utils & Hooks horaires
  const parseHourly = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
      try { 
        return JSON.parse(raw); 
      } catch { 
        return []; 
      }
    }
    return [];
  };

  // useEffect conservés
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://backend.csibon.app/categories_easy_drinks/categories');
        setCategories_easydrinks(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des catégories', error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (productType === 'food') {
      setForGourd(false);
      setForMug(false);
      setBio(false);
      setForBox(true);
      setPricingMode("perUnit");
      setUnitVolume(null);
      SetProduct_category('food');
    } else {
      setForBox(false);
      SetProduct_category('drink');
    }
  }, [productType]);

  useEffect(() => {
    const fetchContainers = async () => {
      try {
        const response = await axiosInstance.get('/drinks/containers');
        setContainers(response.data);
        filterContainers(response.data, forGourd, forMug);
      } catch (error) {
        console.error('Erreur lors de la récupération des contenants', error);
      }
    };
    fetchContainers();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axiosInstance.get(`/drinks/drink-establishment-links/${id_etablissement}`);
        setProducts(response.data);
        console.log("Produits récupérés:", response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des produits', error);
      }
    };
    fetchProducts();
  }, [id_etablissement]);

  useEffect(() => {
    const fetchDrinks = async () => {
      try {
        const response = await axiosInstance.get('/drinks/drinks');
        setDrinks(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des boissons', error);
      }
    };
    fetchDrinks();
  }, []);

  useEffect(() => {
    const fetchAndSetEstablishment = async () => {
      const establishmentData = await fetchEstablishment(id_etablissement);
      if (establishmentData) {
        SetNameEtablissement(establishmentData.name);
        sethasAccess(true);
      } else {
        sethasAccess(false);
      }
    };
    fetchAndSetEstablishment();
  }, [id_etablissement]);

  useEffect(() => {
    const fetchContainers = async () => {
      console.log(`https://backend.csibon.app/container_chr/containers/establishment/${id_etablissement}`)
      try {
        const response = await fetch(`https://backend.csibon.app/container_chr/containers/establishment/${id_etablissement}`);
        if (!response.ok) {
          throw new Error('Erreur réseau lors de la récupération des contenants.');
        }
        let containers_chr = await response.json();
        setContainers_chr(containers_chr);
      } catch (error) {
        console.error('Erreur lors de la récupération des contenants:', error);
      }
    };
    fetchContainers();
  }, [id_etablissement]);

  useEffect(() => {
    filterContainers(containers, forGourd, forMug, forBox);
  }, [forGourd, forMug, forBox, containers]);

  useEffect(() => {
    if (selectedProductForEdit2) {
      const initialPricingMode = selectedProductForEdit2.unit_price != null ? "perUnit" : "perLiter";
      setPricingMode2(initialPricingMode);
    }
  }, [selectedProductForEdit2]);

  // Pré-remplir l'horaire du produit sélectionné à l'ouverture du modal
  useEffect(() => {
    if (!isEditModalOpen || !selectedProductForEdit) {
      setEditSchedule([]);
      return;
    }
    
    console.log("Produit sélectionné pour édition:", selectedProductForEdit);
    console.log("Horaires bruts du produit:", selectedProductForEdit.hourly);
    
    const parsedSchedule = parseHourly(selectedProductForEdit.hourly);
    console.log("Horaires parsés:", parsedSchedule);
    
    setEditSchedule(parsedSchedule);
  }, [isEditModalOpen, selectedProductForEdit]);

  // Fonctions pour gérer les catégories personnalisées
  const handleCategoriesChange = (updatedCategories) => {
    setCustomCategories(updatedCategories);
  };

  const renderCustomCategories = (categoryIds) => {
    if (!categoryIds || categoryIds.length === 0) return null;
    const productCategories = customCategories.filter(cat => 
      categoryIds.includes(cat.id)
    );
    if (productCategories.length === 0) return null;
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {productCategories.map(category => (
          <span 
            key={category.id}
            style={{
              ...styles.tag,
              backgroundColor: '#f1f5f9',
              color: '#475569',
              border: '1px solid #e2e8f0'
            }}
          >
            {category.full_path || category.name}
          </span>
        ))}
      </div>
    );
  };

  // Fonction pour déplacer un produit
  const moveProduct = async (productId, direction) => {
    try {
      const endpoint = direction === 'up' ? 'move-up' : 'move-down';
      const response = await axiosInstance.put(`/drinks/drink-establishment-links/${productId}/${endpoint}`);
      if (response.status === 200) {
        const productsResponse = await axiosInstance.get(`/drinks/drink-establishment-links/${id_etablissement}`);
        setProducts(productsResponse.data);
        console.log(`Produit déplacé ${direction === 'up' ? 'vers le haut' : 'vers le bas'} avec succès`);
      }
    } catch (error) {
      console.error('Erreur lors du déplacement du produit', error);
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert('Erreur lors du déplacement du produit');
      }
    }
  };

  // Fonctions conservées
  const filterContainers = (containers, forGourd, forMug, forBox) => {
    let filtered = containers;
    if (forGourd) {
      filtered = containers.filter(container => container.gourde);
    } else if (forMug) {
      filtered = containers.filter(container => container.mug);
    } else if (forBox) {
      filtered = containers.filter(container => container.box);
    }
    setFilteredContainers(filtered);
  };

  const getCurrentCategories = (level) => {
    let currentCategories = categories_easydrinks;
    for (let i = 0; i < level; i++) {
      const categoryId = selectedCategoryPath[i];
      const category = currentCategories.find(cat => cat.id === categoryId);
      if (category && category.subCategories) {
        currentCategories = category.subCategories;
      } else {
        return [];
      }
    }
    return currentCategories;
  };

  const handleCategoryChange = (categoryId, level) => {
    if (categoryId === "") {
      setSelectedCategoryPath(selectedCategoryPath.slice(0, level));
    } else {
      const newSelectedPath = [...selectedCategoryPath.slice(0, level), categoryId];
      setSelectedCategoryPath(newSelectedPath);
    }
  };

  const renderCategorySelect = (level) => {
    const currentCategories = getCurrentCategories(level);
    if (level !== 0 && currentCategories.length === 0) return null;

    return (
      <div key={level} style={styles.inputGroup}>
        <label style={styles.label}>
          {level === 0 ? 'Catégorie principale' : `Sous-catégorie niveau ${level}`}
        </label>
        <select
          value={selectedCategoryPath[level] || ''}
          onChange={(e) => handleCategoryChange(e.target.value, level)}
          style={styles.select}
        >
          {level !== 0 && <option value=""><em>Pas de sous-catégorie</em></option>}
          {currentCategories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>
    );
  };

  function renderEditCategorySelect(level, categories) {
    console.log("editSelectedCategoryPath", editSelectedCategoryPath)

    let currentCategories = categories;
    for (let i = 0; i < level; i++) {
      const parentCategoryId = editSelectedCategoryPath[i];
      const parentCategory = currentCategories.find(cat => cat.id === parentCategoryId);
      if (!parentCategory || !parentCategory.subCategories) {
        return null;
      }
      currentCategories = parentCategory.subCategories;
    }

    const handleEditCategoryChange = (selectedCategoryId, level) => {
      let newPath = [...editSelectedCategoryPath];
      newPath[level] = selectedCategoryId;
      newPath = newPath.slice(0, level + 1);
      
      let currentCategory = categories_easydrinks;
      for (let i = 0; i <= level; i++) {
        const categoryId = newPath[i];
        const nextCategory = currentCategory.find(cat => cat.id === categoryId);
        if (nextCategory && nextCategory.subCategories && nextCategory.subCategories.length > 0) {
          currentCategory = nextCategory.subCategories;
          if (i === level) {
            newPath.push("");
          }
        } else {
          break;
        }
      }
      setEditSelectedCategoryPath(newPath);
    };

    const showNoSubcategoryOption = currentCategories.length > 0;

    return (
      <div key={level} style={styles.inputGroup}>
        <label style={styles.label}>
          {level === 0 ? 'Catégorie principale' : `Sous-catégorie niveau ${level}`}
        </label>
        <select
          value={editSelectedCategoryPath[level] || ''}
          onChange={(e) => handleEditCategoryChange(e.target.value, level)}
          style={styles.select}
        >
          {showNoSubcategoryOption && (
            <option style={{paddingTop: 8, paddingBottom: 8}} value="">
              <em>{level === 0 ? 'Sélectionner une catégorie' : 'Pas de sous-catégorie'}</em>
            </option>
          )}
          {currentCategories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>
    );
  }

  const handleScheduleChange = (newSchedule) => {
    setDrinkSchedule(newSchedule);
  };
 
  const handleAddCategory = () => {
    if (currentCategory && !categories.includes(currentCategory)) {
      setCategories([...categories, currentCategory]);
      setCurrentCategory('');
    }
  };
 
  // Fonction pour réinitialiser le formulaire
  const resetForm = () => {
    setDrinkName('');
    setDescription('');
    setPrice('');
    setDiscount('');
    setUnitPrice('');
    setUnitVolume('');
    setImageFile(null);
    setSelectedCategoryPath([]);
    setSelectedCustomCategoryIds([]);
    setDrinkSchedule([]);
    setRefusedContainers([]);
    setProductType('drink');
    setForGourd(false);
    setForMug(false);
    setForBox(false);
    setBio(false);
    setIsVegetarian(false);
    setHasAgreed(false);
    setSelectedContainerId('');
    setCanBeOffered(false);
    setIsVisible(true);
    setIsEnterpriseCodeRequired(false);
    setContenantRequired(false);
    setDepositPrice('');
    setAcceptsCustomerContainer(false);
    setPreconditionedWithDeposit(false);
    setPricingMode('perLiter');
    SetProduct_category('drink');
  };
 
  // Fonctions pour ouvrir/fermer le modal d'ajout
  const openAddModal = () => {
    resetForm();
    setIsAddModalOpen(true);
  };
 
  const closeAddModal = () => {
    setIsAddModalOpen(false);
    resetForm();
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (preconditionedWithDeposit && (isNaN(depositPrice) || depositPrice <= 0)) {
      alert("Le prix de la caution consigne doit être un nombre positif.");
      return;
    }
 
    const discountNumber = parseFloat(discount);
    if (isNaN(discountNumber) || discountNumber < 0 || discountNumber > 100) {
      alert("La réduction doit être un nombre entre 0 et 100.");
      return;
    }
 
    if (!drinkName || !imageFile) {
      alert("Veuillez fournir un nom et une photo pour la boisson.");
      return;
    }
 
    let isPriceValid = false;
    if (pricingMode === 'perLiter') {
      const pricePerMl = parseFloat(price);
      isPriceValid = !isNaN(pricePerMl) && pricePerMl > 0;
    } else if (pricingMode === 'perUnit') {
      const unitPriceValue = parseFloat(unitPrice);
      isPriceValid = !isNaN(unitPriceValue) && unitPriceValue > 0;
    }
 
    // Validation des catégories
    if (selectedCustomCategoryIds.length === 0) {
      alert("Veuillez sélectionner au moins une catégorie pour le produit.");
      return;
    }
 
    try {
      const formData = new FormData();
      formData.append('establishment_id', id_etablissement);
      formData.append('discount', discountNumber);
      
      if ((contenantRequired) && (productType === 'food')) {
        formData.append('for_gourd', forGourd);
        formData.append('for_mug', forMug);
        formData.append('for_box', forBox);
      } else {
        formData.append('for_gourd', false);
        formData.append('for_mug', false);
        formData.append('for_box', false);
      }
 
      if (productType === 'food' && contenantRequired) {
        formData.append('preconditioned_with_deposit', preconditionedWithDeposit);
        formData.append('deposit_price', depositPrice);
        formData.append('accepts_customer_container', acceptsCustomerContainer);
        formData.append('isVegetarian', isVegetarian);
      }
 
      formData.append('EnterpriseCodeRequired', isEnterpriseCodeRequired);
      formData.append('refused_containers', JSON.stringify(refusedContainers));
      formData.append('pricing_mode', pricingMode);
      formData.append('hourly', JSON.stringify(drinkSchedule));
      formData.append('bio', bio);
      formData.append('visible', isVisible);
      formData.append('product_category', product_category);
      formData.append('drink_name', drinkName);
      formData.append('description', description);
      formData.append('container_disposition', hasAgreed);
      formData.append('container_id', selectedContainerId);
      
      // Utiliser les catégories multiples
      formData.append('custom_category_ids', JSON.stringify(selectedCustomCategoryIds));
      
      formData.append('offered_drinks', offeredDrinks);
      formData.append('canBeOffered', canBeOffered);
      formData.append('ingredients', JSON.stringify([]));
 
      if (!hasAgreed) {
        formData.append('container_name', containerName);
        formData.append('container_brand', containerBrand);
        formData.append('container_volume', containerVolume);
        if (containerImage) {
          formData.append('container_image', containerImage);
        }
      }
 
      if (pricingMode === 'perLiter') {
        formData.append('price_per_ml', price);
      } else if (pricingMode === 'perUnit') {
        formData.append('unit_price', unitPrice);
        formData.append('unit_volume_ml', unitVolume);
      }

      // Service mode and differentiated prices
      formData.append('service_mode', serviceMode);
      if (serviceMode === 'both') {
        if (unitPricePickup) formData.append('unit_price_pickup', unitPricePickup);
        if (unitPriceDelivery) formData.append('unit_price_delivery', unitPriceDelivery);
      }
 
      if (imageFile) {
        formData.append('image', imageFile);
      }
 
      console.log('---------------------------------------------');
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + (pair[1]?.name ? pair[1].name : pair[1]));
      }
 
      const response = await axiosInstance.post('/drinks/drink-establishment-links', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
 
      if (response.status === 201) {
        alert('Produit ajouté avec succès à l\'établissement!');
        closeAddModal();
        window.location.reload();
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout du produit', error);
    }
  };
 
  const deleteProduct = async (linkId) => {
    try {
      const response = await axiosInstance.delete(`/drinks/drink-establishment-links/${linkId}`);
      if (response.status === 200) {
        alert('Produit supprimé avec succès !');
        setProducts(products.filter(product => product.id !== linkId));
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du produit', error);
    }
  };
 
  const openEditModal = (product) => {
    console.log("Ouverture du modal d'édition pour le produit:", product);
    
    setSelectedProductForEdit(product);
    setSelectedProductForEdit2(product);
    setSelectedProductIngredients(product.ingredients || []);
    setEditOfferedDrinks(product.drinks_offered || 0);
    
    // Gestion des catégories multiples
    const productCategoryIds = product.custom_categories 
      ? product.custom_categories.map(cat => cat.id) 
      : [];
    setEditSelectedCustomCategoryIds(productCategoryIds);
 
    // Garder l'ancien système pour rétrocompatibilité
    const categoryPath = product.categories_boisson?.map(cat => cat.id) || [];
    setEditSelectedCategoryPath(categoryPath);
    
    setDrinksCanBeOffered(product.drinks_offered || false);
    
    // Les horaires seront gérés par le useEffect dédié
    setIsEditModalOpen(true);
  };

  // Pré-remplir l'horaire du produit sélectionné à l'ouverture du modal
useEffect(() => {
  console.log("=== DÉBUT useEffect horaires ===");
  console.log("isEditModalOpen:", isEditModalOpen);
  console.log("selectedProductForEdit:", selectedProductForEdit);
  
  if (!isEditModalOpen || !selectedProductForEdit) {
    console.log("Réinitialisation editSchedule à []");
    setEditSchedule([]);
    return;
  }
  
  console.log("Horaires bruts du produit:", selectedProductForEdit.hourly);
  console.log("Type des horaires bruts:", typeof selectedProductForEdit.hourly);
  
  let parsedSchedule = [];
  try {
    if (selectedProductForEdit.hourly) {
      if (typeof selectedProductForEdit.hourly === 'string') {
        parsedSchedule = JSON.parse(selectedProductForEdit.hourly);
      } else if (Array.isArray(selectedProductForEdit.hourly)) {
        parsedSchedule = selectedProductForEdit.hourly;
      }
    }
  } catch (error) {
    console.error("Erreur lors du parsing des horaires:", error);
    parsedSchedule = [];
  }
  
  console.log("Horaires parsés:", parsedSchedule);
  console.log("=== FIN useEffect horaires ===");
  
  setEditSchedule(parsedSchedule);
}, [isEditModalOpen, selectedProductForEdit]);
 
  const closeEditModal = () => {
    setSelectedProductForEdit(null);
    setSelectedProductForEdit2(null);
    setEditSchedule([]); // Reset des horaires
    setIsEditModalOpen(false);
  };
 
  const handleEditSubmit = async (updatedProductData) => {
    
    const formData = new FormData();
 
    if (preconditionedWithDeposit && (isNaN(depositPrice) || depositPrice <= 0)) {
      alert("Le prix de la caution consigne doit être un nombre positif.");
      return;
    }
 
    console.log("updatedProductData : ", updatedProductData);
 
    formData.append('bio', updatedProductData.bio);
    
    if (updatedProductData.container_disposition) {
      formData.append('id_container_gourdefriendly', updatedProductData.id_container_gourdefriendly);
    }
    
    formData.append('for_gourde', updatedProductData.for_gourde);
    formData.append('for_mug', updatedProductData.for_mug);
    formData.append('for_box', updatedProductData.for_box);
    formData.append('offered_drinks', editOfferedDrinks);
 
    if (updatedProductData.product_category === 'food') {
      formData.append('preconditioned_with_deposit', updatedProductData.preconditioned_with_deposit);
      formData.append('deposit_price', updatedProductData.deposit_price);
      formData.append('accepts_customer_container', updatedProductData.accepts_customer_container);
      formData.append('isVegetarian', updatedProductData.is_vegetarian);
    }
 
    formData.append('refused_containers', JSON.stringify(updatedProductData.refused_containers_id || []));

    // Utiliser les horaires édités directement depuis l'état editSchedule
    console.log("Horaires à sauvegarder:", editSchedule);
    formData.append('hourly', JSON.stringify(editSchedule));

    formData.append('container_disposition', updatedProductData.container_disposition);
    formData.append('discount', updatedProductData.discount);
 
    if (pricingMode2 === 'perLiter') {
      formData.append('price_per_ml', updatedProductData.price_per_ml);
      formData.append('unit_price', null);
      formData.append('unit_volume_ml', null);
    } else if (pricingMode2 === 'perUnit') {
      formData.append('unit_price', updatedProductData.unit_price);
      formData.append('unit_volume_ml', updatedProductData.unit_volume_ml);
      formData.append('price_per_ml', null);
    }

    // Service mode and differentiated prices
    formData.append('service_mode', updatedProductData.service_mode || 'pickup');
    if (updatedProductData.service_mode === 'both') {
      if (updatedProductData.unit_price_pickup) formData.append('unit_price_pickup', updatedProductData.unit_price_pickup);
      if (updatedProductData.unit_price_delivery) formData.append('unit_price_delivery', updatedProductData.unit_price_delivery);
    }

    // Utiliser les catégories multiples
    formData.append('custom_category_ids', JSON.stringify(editSelectedCustomCategoryIds));
    console.log("editSelectedCustomCategoryIds:", editSelectedCustomCategoryIds);
    console.log("Données envoyées pour les catégories:", JSON.stringify(editSelectedCustomCategoryIds));
    
    formData.append('name', updatedProductData.name);
    formData.append('description', updatedProductData.description);
    formData.append('EnterpriseCodeRequired', updatedProductData.EnterpriseCodeRequired);
    formData.append('canBeOffered', drinkcCanBeOffered);
 
    formData.append('ingredients', JSON.stringify([]));
 
    if (updatedProductData.imageFile) {
      console.log(updatedProductData.imageFile);
      formData.append('image', updatedProductData.imageFile);
    }
 
    for (let [key, value] of formData.entries()) {
      console.log(key, " : ", value);
    }
 
    console.log(`https://backend.csibon.app/drinks/drink-establishment-links/${updatedProductData.id}`);
 
    try {
      const response = await fetch(`https://backend.csibon.app/drinks/drink-establishment-links/${updatedProductData.id}`, {
        method: 'PUT',
        // headers: {
        //   // 'Authorization': `Bearer `,
        // },
        body: formData
      });
 
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
 
      const data = await response.json();
      console.log(data);
      closeEditModal();
      // Recharger les produits pour voir les modifications
      const productsResponse = await axiosInstance.get(`/drinks/drink-establishment-links/${id_etablissement}`);
      setProducts(productsResponse.data);
    } catch (error) {
      console.error('Erreur lors de la mise à jour du produit', error);
    }
  };
 
  const filterContainersForSelection = () => {
    if (selectedProductForEdit?.for_gourde) {
      return containers.filter(container => container.gourde);
    } else if (selectedProductForEdit?.for_mug) {
      return containers.filter(container => container.mug);
    }
    return containers;
  };
 
  const toggleVisibility = async (product) => {
    try {
      const response = await axiosInstance.put(`drinks/update-visibility/${product.id}`, {
        visible: !product.visible
      });
  
      if (response.status === 200) {
        setProducts(products.map(p => {
          if (p.id === product.id) {
            return { ...p, visible: !p.visible };
          }
          return p;
        }));
        const newVisibilityText = product.visible ? 'masqué' : 'affiché';
        console.log(`${product.name} est maintenant ${newVisibilityText}.`);
        setTimeout(() => {}, 100);
      }
    } catch (error) {
      console.error('Erreur lors de la modification de la visibilité', error);
      alert('Erreur lors de la modification de la visibilité');
    }
  };
 
  function renderCategories(categories) {
    return (
      <div style={styles.productTags}>
        {categories.map(category => (
          <span 
            key={category.id}
            style={{...styles.tag, ...styles.tagGreen}}
          >
            {category.name}
          </span>
        ))}
      </div>
    );
  }
 
  // Fonctions de filtrage des produits
  const filterProducts = (productList) => {
    let filtered = productList;
    if (searchTerm) {
      filtered = filtered.filter(product => 
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (filterCategory !== 'all') {
      if (filterCategory === 'no-category') {
        filtered = filtered.filter(product => 
          (!product.custom_categories || product.custom_categories.length === 0) &&
          (!product.categories_boisson || product.categories_boisson.length === 0)
        );
      } else {
        filtered = filtered.filter(product => 
          product.custom_categories?.some(cat => cat.id === parseInt(filterCategory)) ||
          product.categories_boisson?.some(cat => cat.id === parseInt(filterCategory))
        );
      }
    }
    return filtered;
  };
 
  // Fonction pour séparer les produits par type
  const drinkProducts = filterProducts(products.filter(product => product.product_category === 'drink'));
  const foodProducts = filterProducts(products.filter(product => product.product_category === 'food'));
 
  // Fonction pour obtenir toutes les catégories utilisées
  const getAllUsedCategories = () => {
    const usedCategories = new Set();
    products.forEach(product => {
      if (product.custom_categories) {
        product.custom_categories.forEach(cat => usedCategories.add(cat));
      }
    });
    return Array.from(usedCategories);
  };
 
  // Fonction pour rendre une liste de produits
  const renderProductList = (productList, emptyMessage, emptyIcon) => {
    if (productList.length === 0) {
      return (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>{emptyIcon}</div>
          <div style={styles.emptyTitle}>Aucun produit trouvé</div>
          <div style={styles.emptyDescription}>{emptyMessage}</div>
        </div>
      );
    }
    return (
      <div style={styles.productGrid}>
        {productList.map(product => {
          const schedulePreview = parseHourly(product.hourly);
          return (
            <div key={product.id} style={styles.productCard}>
              {/* Image */}
              <img
                src={product.image_url || product.drink?.url_image || '/placeholder.jpg'}
                alt={product.name}
                style={styles.productImage}
              />
              {/* Informations */}
              <div style={styles.productInfo}>
                <h3 style={styles.productName}>{product.name}</h3>
                <p style={styles.productDescription}>{product.description}</p>
                
                <div style={styles.productTags}>
                  {product.for_gourde && (
                    <span style={{...styles.tag, ...styles.tagBlue}}>Gourde</span>
                  )}
                  {product.for_mug && (
                    <span style={{...styles.tag, ...styles.tagBlue}}>Mug</span>
                  )}
                  {product.for_box && (
                    <span style={{...styles.tag, ...styles.tagBlue}}>Box</span>
                  )}
                  {product.bio && (
                    <span style={{...styles.tag, ...styles.tagGreen}}>Bio</span>
                  )}
                  {product.is_vegetarian && (
                    <span style={{...styles.tag, ...styles.tagGreen}}>Végétarien</span>
                  )}
                  {product.discount > 0 && (
                    <span style={{...styles.tag, ...styles.tagRed}}>-{product.discount}%</span>
                  )}
                  {!product.visible && (
                    <span style={{...styles.tag, ...styles.tagRed}}>Masqué</span>
                  )}
                </div>

                {/* Aperçu rapide des horaires (si présents) */}
                {Array.isArray(schedulePreview) && schedulePreview.length > 0 && (
                  <div style={{ fontSize: '12px', color: '#64748b' }}>
                    🕒 Dispo: {schedulePreview.map((s, idx) => (
                      <span key={idx}>
                        {s.jours?.join(', ')} {s.ouverture}–{s.fermeture}{idx < schedulePreview.length - 1 ? ' • ' : ''}
                      </span>
                    ))}
                  </div>
                )}
 
                <div style={{ fontSize: '14px', color: '#64748b' }}>
                  {product.price_per_ml && (
                    <div>Prix au litre: {product.price_per_ml}€</div>
                  )}
                  {product.unit_price && (
                    <div>Prix à l'unité: {product.unit_price}€</div>
                  )}
                  {product.unit_volume_ml && product.unit_volume_ml !== 0 && (
                    <div>Volume unitaire: {product.unit_volume_ml} ml</div>
                  )}
                  <div style={{ 
                    color: product.discount > 50 ? '#dc2626' : 'inherit',
                    fontWeight: product.discount > 50 ? '600' : 'normal'
                  }}>
                    Réduction: {product.discount ? `${product.discount}%` : 'Aucune'}
                  </div>
                </div>
 
                {product.drinks_offered && (
                  <div style={{fontSize: '12px', color: '#64748b'}}>
                    ✓ Cette boisson peut être offerte
                  </div>
                )}
 
                {/* Contenant */}
                {product.container_disposition && product.container_info && (
                  <div>
                    <div style={{...styles.label, marginBottom: '8px'}}>Contenant fourni:</div>
                    <div style={styles.containerOption}>
                      {product.container_info.image_url && (
                        <img 
                          src={`https://backend.csibon.app/static/container_images/${product.container_info.image_url}`} 
                          alt={product.container_info.name}
                          style={styles.containerImage}
                        />
                      )}
                      <div>
                        <div style={{fontWeight: '500'}}>
                          {product.container_info.name}
                        </div>
                        <div style={{fontSize: '12px', color: '#64748b'}}>
                          Marque: {product.container_info.brand}
                          <br />
                          Volume: {product.container_info.volume}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
 
                {/* Catégories personnalisées (nouvelles) */}
                {product.custom_categories && product.custom_categories.length > 0 && (
                  <div>
                    <div style={{...styles.label, marginBottom: '8px'}}>Catégories:</div>
                    {renderCustomCategories(product.custom_categories.map(cat => cat.id))}
                  </div>
                )}
 
                {/* Anciennes catégories (pour rétrocompatibilité) */}
                {product.categories_boisson && product.categories_boisson.length > 0 && 
                 (!product.custom_categories || product.custom_categories.length === 0) && (
                  <div>
                    <div style={{...styles.label, marginBottom: '8px'}}>Catégories (ancien système):</div>
                    {renderCategories(product.categories_boisson)}
                  </div>
                )}
 
                {/* Options spéciales */}
                <div style={{fontSize: '12px', color: '#64748b'}}>
                  {product.EnterpriseCodeRequired && (
                    <div>🏢 Code entreprise requis</div>
                  )}
                </div>
              </div>
 
              {/* Actions */}
              <div style={styles.productActions}>
                {/* Boutons de réorganisation */}
                <div style={styles.reorderButtons}>
                  <button
                    onClick={() => moveProduct(product.id, 'up')}
                    style={{
                      ...styles.reorderButton,
                      marginBottom: '4px'
                    }}
                    title="Déplacer vers le haut"
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#f3f4f6';
                      e.target.style.borderColor = '#9ca3af';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.borderColor = '#d1d5db';
                    }}
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveProduct(product.id, 'down')}
                    style={styles.reorderButton}
                    title="Déplacer vers le bas"
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#f3f4f6';
                      e.target.style.borderColor = '#9ca3af';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.borderColor = '#d1d5db';
                    }}
                  >
                    ↓
                  </button>
                </div>
                
                {/* Actions existantes */}
                <div style={styles.actionButtons}>
                  <button
                    onClick={() => openEditModal(product)}
                    style={{
                      ...styles.button,
                      ...styles.secondaryButton,
                      fontSize: '14px',
                      padding: '8px 16px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#e2e8f0';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#f1f5f9';
                    }}
                  >
                    ✏️ Modifier
                  </button>
                  <button
                    onClick={() => deleteProduct(product.id)}
                    style={{
                      ...styles.button,
                      ...styles.dangerButton,
                      fontSize: '14px',
                      padding: '8px 16px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#b91c1c';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#dc2626';
                    }}
                  >
                    🗑️ Supprimer
                  </button>
                  <button
                    onClick={() => toggleVisibility(product)}
                    disabled={updatingVisibility === product.id}
                    style={{
                      ...styles.button,
                      ...(product.visible ? styles.dangerButton : styles.primaryButton),
                      fontSize: '14px',
                      padding: '8px 16px',
                      opacity: updatingVisibility === product.id ? 0.7 : 1
                    }}
                  >
                    {updatingVisibility === product.id 
                      ? '⏳ Modification...' 
                      : (product.visible ? '👁️ Masquer' : '👁️ Afficher')
                    }
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
 
  if (!hasAccess) {
    return <AccessDeniedMessage />;
  }
 
  return (
    <div style={styles.container}>
      <AdminNavbar establishmentId={id_etablissement} name={name_etablissement} />
      
      <button
        onClick={() => navigate('/accueil')}
        style={styles.backButton}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#e2e8f0';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#f1f5f9';
        }}
      >
        ← Retour à l'accueil
      </button>
 
      <div style={styles.content}>
        {/* Gestionnaire de catégories personnalisées */}
        <CategoryManager 
          establishmentId={id_etablissement}
          onCategoriesChange={handleCategoriesChange}
        />
 
        {/* Header avec bouton d'ajout */}
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <h1 style={styles.title}>Gestion des Produits</h1>
            <p style={styles.subtitle}>
              Gérer les produits pour l'établissement {name_etablissement}
            </p>
          </div>
          <button
            onClick={openAddModal}
            style={styles.addButton}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '20px' }}>+</span>
            Ajouter un produit
          </button>
        </div>
 
        {/* Filtres et recherche */}
        <div style={styles.section}>
          <div style={styles.filterSection}>
            <input
              type="text"
              placeholder="Rechercher un produit..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchBox}
            />
          </div>
        </div>
 
        {/* Section Boissons */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>
            🍹 Boissons ({drinkProducts.length})
          </div>
          {renderProductList(
            drinkProducts, 
            searchTerm || filterCategory !== 'all' 
              ? "Aucune boisson ne correspond aux critères de recherche."
              : "Aucune boisson n'a été ajoutée à cet établissement.",
            "🍹"
          )}
        </div>
 
        {/* Section Nourriture */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>
            🍽️ Nourriture ({foodProducts.length})
          </div>
          {renderProductList(
            foodProducts, 
            searchTerm || filterCategory !== 'all'
              ? "Aucun produit alimentaire ne correspond aux critères de recherche."
              : "Aucun produit alimentaire n'a été ajouté à cet établissement.",
            "🍽️"
          )}
        </div>
      </div>
 
      {/* Modal d'ajout de produit */}
      {isAddModalOpen && (
        <div style={styles.modal} onClick={closeAddModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Ajouter un nouveau produit</h2>
            
            <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
              
              {/* Type de produit */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Type de produit
                </div>
                <div style={styles.toggleSection}>
                  <span style={{
                    fontWeight: productType === 'drink' ? '600' : '400',
                    color: productType === 'drink' ? '#059669' : '#64748b'
                  }}>
                    Boisson
                  </span>
                  <button
                    type="button"
                    style={{
                      ...styles.toggleButton,
                      ...(productType === 'food' ? styles.toggleButtonActive : {})
                    }}
                    onClick={() => setProductType(productType === 'drink' ? 'food' : 'drink')}
                  >
                    <div style={{
                      ...styles.toggleThumb,
                      ...(productType === 'food' ? styles.toggleThumbActive : {})
                    }}></div>
                  </button>
                  <span style={{
                    fontWeight: productType === 'food' ? '600' : '400',
                    color: productType === 'food' ? '#059669' : '#64748b'
                  }}>
                    Nourriture
                  </span>
                </div>
              </div>
 
              {/* Options d'accès */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Options d'accès
                </div>
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={isEnterpriseCodeRequired}
                    onChange={(e) => setIsEnterpriseCodeRequired(e.target.checked)}
                    style={styles.checkboxInput}
                  />
                  Disponible uniquement pour les utilisateurs avec code entreprise
                </label>
 
                {productType === 'food' && (
                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={contenantRequired}
                      onChange={(e) => setContenantRequired(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Contenant requis
                  </label>
                )}
              </div>
 
              {/* Options de contenant pour nourriture */}
              {productType === 'food' && contenantRequired && (
                <div>
                  <div style={styles.sectionTitleSmall}>
                    Options de Contenant
                  </div>
                  
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Prix de la caution consigne (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={depositPrice}
                      onChange={(e) => setDepositPrice(e.target.value)}
                      style={styles.input}
                      placeholder="0.00"
                    />
                  </div>

                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={acceptsCustomerContainer}
                      onChange={(e) => setAcceptsCustomerContainer(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Accepte contenant du client
                  </label>
                </div>
              )}

              {/* Informations de base */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Informations de base
                </div>
                
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nom du produit *</label>
                  <input
                    type="text"
                    value={drinkName}
                    onChange={(e) => setDrinkName(e.target.value)}
                    style={styles.input}
                    placeholder="Entrez le nom du produit"
                    onFocus={(e) => {
                      e.target.style.borderColor = '#059669';
                      e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#d1d5db';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Description</label>
                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={styles.textarea}
                    placeholder="Décrivez votre produit..."
                    onFocus={(e) => {
                      e.target.style.borderColor = '#059669';
                      e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#d1d5db';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                {productType === 'food' && (
                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={isVegetarian}
                      onChange={(e) => setIsVegetarian(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Produit végétarien
                  </label>
                )}
              </div>

              {/* Catégories personnalisées multiples */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Catégories
                </div>
                <CategorySelectorMultiple
                  establishmentId={id_etablissement}
                  selectedCategoryIds={selectedCustomCategoryIds}
                  onCategoriesChange={setSelectedCustomCategoryIds}
                  label="Sélectionner des catégories *"
                />
                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                  Vous pouvez sélectionner plusieurs catégories, y compris des catégories de niveaux différents
                </div>
              </div>

              {/* Contenant */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Fourniture de contenant
                </div>
                
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={hasAgreed}
                    onChange={(e) => setHasAgreed(e.target.checked)}
                    style={styles.checkboxInput}
                  />
                  Je m'engage à fournir un contenant
                </label>

                {hasAgreed && (
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Contenant</label>
                    <select
                      value={selectedContainerId}
                      onChange={(e) => setSelectedContainerId(e.target.value)}
                      style={styles.select}
                    >
                      <option value="">Choisissez un contenant...</option>
                      {containers_chr.map((container) => (
                        <option key={container.id} value={container.id}>
                          {container.name} ({container.brand})
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              {/* Type de contenant pour boissons */}
              {productType === 'drink' && (
                <div>
                  <div style={styles.sectionTitleSmall}>
                    Type de contenant
                  </div>
                  
                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={forGourd}
                      onChange={(e) => setForGourd(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Pour Gourde
                  </label>
                  
                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={forMug}
                      onChange={(e) => setForMug(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Pour Mug
                  </label>

                  <label style={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={bio}
                      onChange={(e) => setBio(e.target.checked)}
                      style={styles.checkboxInput}
                    />
                    Boisson bio
                  </label>
                </div>
              )}

              {/* Horaires */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Horaires de disponibilité
                </div>
                <DrinkSchedule onScheduleChange={handleScheduleChange} />
              </div>

              {/* Prix */}
              {productType === 'drink' && (
                <div>
                  <div style={styles.sectionTitleSmall}>
                    Tarification
                  </div>
                  
                  <div style={styles.radioGroup}>
                    <label style={{
                      ...styles.radioOption,
                      ...(pricingMode === 'perLiter' ? styles.radioOptionSelected : {})
                    }}>
                      <input
                        type="radio"
                        name="pricingMode"
                        value="perLiter"
                        checked={pricingMode === 'perLiter'}
                        onChange={(e) => setPricingMode(e.target.value)}
                        style={styles.checkboxInput}
                      />
                      Prix au litre
                    </label>
                    <label style={{
                      ...styles.radioOption,
                      ...(pricingMode === 'perUnit' ? styles.radioOptionSelected : {})
                    }}>
                      <input
                        type="radio"
                        name="pricingMode"
                        value="perUnit"
                        checked={pricingMode === 'perUnit'}
                        onChange={(e) => setPricingMode(e.target.value)}
                        style={styles.checkboxInput}
                      />
                      Prix à l'unité
                    </label>
                  </div>

                  {pricingMode === 'perLiter' && (
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Prix au litre (€)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        style={styles.input}
                        placeholder="0.00"
                      />
                    </div>
                  )}

                  {pricingMode === 'perUnit' && (
                    <>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Prix à l'unité (€)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={unitPrice}
                          onChange={(e) => setUnitPrice(e.target.value)}
                          style={styles.input}
                          placeholder="0.00"
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Volume par unité (cl)</label>
                        <input
                          type="number"
                          value={unitVolume}
                          onChange={(e) => setUnitVolume(e.target.value)}
                          style={styles.input}
                          placeholder="25"
                        />
                      </div>
                    </>
                  )}
                </div>
              )}

              {productType === 'food' && (
                <div>
                  <div style={styles.sectionTitleSmall}>
                    Prix
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Prix (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      style={styles.input}
                      placeholder="0.00"
                    />
                  </div>
                </div>
              )}

              {/* Mode de service */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Mode de service
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Disponibilité</label>
                  <select
                    value={serviceMode}
                    onChange={(e) => setServiceMode(e.target.value)}
                    style={styles.select}
                  >
                    <option value="pickup">Sur place uniquement</option>
                    <option value="delivery">Livraison uniquement</option>
                    <option value="both">Les deux (sur place et livraison)</option>
                  </select>
                </div>

                {/* Prix différenciés quand service_mode = 'both' */}
                {serviceMode === 'both' && (
                  <>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Prix sur place (€) - optionnel</label>
                      <input
                        type="number"
                        step="0.01"
                        value={unitPricePickup}
                        onChange={(e) => setUnitPricePickup(e.target.value)}
                        style={styles.input}
                        placeholder="Laisser vide pour utiliser le prix principal"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Prix livraison (€) - optionnel</label>
                      <input
                        type="number"
                        step="0.01"
                        value={unitPriceDelivery}
                        onChange={(e) => setUnitPriceDelivery(e.target.value)}
                        style={styles.input}
                        placeholder="Laisser vide pour utiliser le prix principal"
                      />
                    </div>
                  </>
                )}
              </div>

              {/* Réduction */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Réduction
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Réduction (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    style={{
                      ...styles.input,
                      borderColor: (discount < 0 || discount > 100) ? '#dc2626' : '#d1d5db'
                    }}
                    placeholder="0"
                  />
                  {(discount < 0 || discount > 100) && (
                    <span style={{ color: '#dc2626', fontSize: '14px' }}>
                      La réduction doit être entre 0 et 100%
                    </span>
                  )}
                </div>
              </div>

              {/* Image */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Image du produit
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Choisir une image *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImageFile(e.target.files[0])}
                    style={styles.input}
                  />
                </div>
              </div>

              {/* Options de visibilité */}
              <div>
                <div style={styles.sectionTitleSmall}>
                  Visibilité et offres
                </div>
                
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={canBeOffered}
                    onChange={(e) => setCanBeOffered(e.target.checked)}
                    style={styles.checkboxInput}
                  />
                  Produit peut être offert
                </label>

                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={isVisible}
                    onChange={(e) => setIsVisible(e.target.checked)}
                    style={styles.checkboxInput}
                  />
                  Produit visible dans l'application
                </label>
              </div>

              {/* Actions du modal */}
              <div style={styles.modalActions}>
                <button
                  type="button"
                  onClick={closeAddModal}
                  style={{
                    ...styles.button,
                    ...styles.secondaryButton
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e2e8f0';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f1f5f9';
                  }}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  style={{
                    ...styles.button,
                    ...styles.primaryButton
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#047857';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#059669';
                  }}
                >
                  Ajouter le produit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de modification */}
      {isEditModalOpen && (
        <div style={styles.modal} onClick={closeEditModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Modifier le produit</h2>
            
            {/* Code entreprise requis */}
            <label style={styles.checkbox}>
              <input
                type="checkbox"
                checked={selectedProductForEdit?.EnterpriseCodeRequired || false}
                onChange={(e) => setSelectedProductForEdit({ 
                  ...selectedProductForEdit, 
                  EnterpriseCodeRequired: e.target.checked 
                })}
                style={styles.checkboxInput}
              />
              Disponible uniquement pour les utilisateurs avec code entreprise
            </label>

            {/* Végétarien pour nourriture */}
            {selectedProductForEdit?.product_category === 'food' && (
              <>
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={selectedProductForEdit?.is_vegetarian || false}
                    onChange={(e) => setSelectedProductForEdit({ 
                      ...selectedProductForEdit, 
                      is_vegetarian: e.target.checked 
                    })}
                    style={styles.checkboxInput}
                  />
                  Produit végétarien
                </label>

                {/* Options de contenant pour nourriture */}
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Prix de la caution consigne (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={selectedProductForEdit?.deposit_price || ''}
                    onChange={(e) => setSelectedProductForEdit({ 
                      ...selectedProductForEdit, 
                      deposit_price: e.target.value 
                    })}
                    style={styles.input}
                  />
                </div>

                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={selectedProductForEdit?.accepts_customer_container || false}
                    onChange={(e) => setSelectedProductForEdit({ 
                      ...selectedProductForEdit, 
                      accepts_customer_container: e.target.checked 
                    })}
                    style={styles.checkboxInput}
                  />
                  Accepte contenant du client
                </label>
              </>
            )}

            {/* Nom */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Nom du produit</label>
              <input
                type="text"
                value={selectedProductForEdit?.name || ''}
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  name: e.target.value
                })}
                style={styles.input}
              />
            </div>

            {/* Description */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Description</label>
              <textarea
                value={selectedProductForEdit?.description || ''}
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  description: e.target.value
                })}
                style={styles.textarea}
              />
            </div>

            {/* Catégories personnalisées multiples */}
            <div>
              <label style={styles.label}>Catégories</label>
              <CategorySelectorMultiple
                establishmentId={id_etablissement}
                selectedCategoryIds={editSelectedCustomCategoryIds}
                onCategoriesChange={setEditSelectedCustomCategoryIds}
                label="Sélectionner des catégories"
              />
            </div>

            {/* Bio pour boissons */}
            {selectedProductForEdit?.product_category === 'drink' && (
              <label style={styles.checkbox}>
                <input
                  type="checkbox"
                  checked={selectedProductForEdit?.bio || false}
                  onChange={(e) => setSelectedProductForEdit({ 
                    ...selectedProductForEdit, 
                    bio: e.target.checked 
                  })}
                  style={styles.checkboxInput}
                />
                Produit bio
              </label>
            )}

            {/* Remise de contenant */}
            <label style={styles.checkbox}>
              <input
                type="checkbox"
                checked={selectedProductForEdit?.container_disposition || false}
                onChange={(e) => setSelectedProductForEdit({ 
                  ...selectedProductForEdit, 
                  container_disposition: e.target.checked 
                })}
                style={styles.checkboxInput}
              />
              Remise d'un contenant
            </label>

            {/* Sélection du contenant */}
            {selectedProductForEdit?.container_disposition && (
              <div style={styles.inputGroup}>
                <label style={styles.label}>Contenant</label>
                <select
                  value={selectedProductForEdit?.id_container_gourdefriendly || ''}
                  onChange={(e) => setSelectedProductForEdit({
                    ...selectedProductForEdit,
                    id_container_gourdefriendly: e.target.value
                  })}
                  style={styles.select}
                >
                  <option value="">Choisissez un contenant...</option>
                  {containers_chr.map((container) => (
                    <option key={container.id} value={container.id}>
                      {container.name} ({container.brand})
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Type de contenant pour boissons */}
            {selectedProductForEdit?.product_category === 'drink' && (
              <>
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={selectedProductForEdit?.for_gourde || false}
                    onChange={(e) => setSelectedProductForEdit({ 
                      ...selectedProductForEdit, 
                      for_gourde: e.target.checked 
                    })}
                    style={styles.checkboxInput}
                  />
                  Pour Gourde
                </label>
                
                <label style={styles.checkbox}>
                  <input
                    type="checkbox"
                    checked={selectedProductForEdit?.for_mug || false}
                    onChange={(e) => setSelectedProductForEdit({ 
                      ...selectedProductForEdit, 
                      for_mug: e.target.checked 
                    })}
                    style={styles.checkboxInput}
                  />
                  Pour Mug
                </label>
              </>
            )}

            {/* Horaires avec pré-remplissage */}
            {/* <div>
              <label style={styles.label}>Horaires de disponibilité</label>
              <DrinkSchedule
                key={`edit-${selectedProductForEdit?.id}`}  // Force le remount avec une clé unique
                schedule={editSchedule}                      // Horaires pré-remplis
                onScheduleChange={(newSchedule) => {
                  console.log("Nouveaux horaires reçus:", newSchedule);
                  setEditSchedule(newSchedule);              // Mise à jour de l'état
                  setSelectedProductForEdit(prev => prev ? { 
                    ...prev, 
                    hourly: newSchedule 
                  } : prev);
                }}
              />
            </div> */}

<div>
  <label style={styles.label}>Horaires de disponibilité</label>
  <DrinkSchedule
    key={`edit-${selectedProductForEdit?.id}`}
    schedule={editSchedule}  // CETTE LIGNE EST IMPORTANTE - elle passe les horaires existants
    onScheduleChange={(newSchedule) => {
      console.log("Nouveaux horaires reçus dans le modal:", newSchedule);
      setEditSchedule(newSchedule);
      setSelectedProductForEdit(prev => prev ? { 
        ...prev, 
        hourly: newSchedule 
      } : prev);
    }}
  />
</div>

            {/* Peut être offert */}
            <label style={styles.checkbox}>
              <input
                type="checkbox"
                checked={drinkcCanBeOffered}
                onChange={(e) => setDrinksCanBeOffered(e.target.checked)}
                style={styles.checkboxInput}
              />
              Produit peut être offert
            </label>

            {/* Contenants refusés */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Contenants refusés</label>
              <select
                multiple
                value={selectedProductForEdit?.refused_containers_id || []}
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  refused_containers_id: [...e.target.selectedOptions].map(o => o.value)
                })}
                style={{...styles.select, minHeight: '120px'}}
              >
                {filterContainersForSelection().map(container => (
                  <option key={container.id} value={container.id}>
                    {container.name} ({container.brand})
                  </option>
                ))}
              </select>
            </div>

            {/* Tarification pour boissons */}
            {selectedProductForEdit?.product_category === 'drink' && (
              <>
                <div>
                  <label style={styles.label}>Mode de tarification</label>
                  <div style={styles.radioGroup}>
                    <label style={{
                      ...styles.radioOption,
                      ...(pricingMode2 === 'perLiter' ? styles.radioOptionSelected : {})
                    }}>
                      <input
                        type="radio"
                        name="pricingMode2"
                        value="perLiter"
                        checked={pricingMode2 === 'perLiter'}
                        onChange={(e) => setPricingMode2(e.target.value)}
                        style={styles.checkboxInput}
                      />
                      Prix au litre
                    </label>
                    <label style={{
                      ...styles.radioOption,
                      ...(pricingMode2 === 'perUnit' ? styles.radioOptionSelected : {})
                    }}>
                      <input
                        type="radio"
                        name="pricingMode2"
                        value="perUnit"
                        checked={pricingMode2 === 'perUnit'}
                        onChange={(e) => setPricingMode2(e.target.value)}
                        style={styles.checkboxInput}
                      />
                      Prix à l'unité
                    </label>
                  </div>
                </div>

                {pricingMode2 === 'perLiter' && (
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Prix au litre (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={selectedProductForEdit?.price_per_ml || ''}
                      onChange={(e) => setSelectedProductForEdit({
                        ...selectedProductForEdit,
                        price_per_ml: e.target.value
                      })}
                      style={styles.input}
                    />
                  </div>
                )}

                {pricingMode2 === 'perUnit' && (
                  <>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Prix à l'unité (€)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={selectedProductForEdit?.unit_price || ''}
                        onChange={(e) => setSelectedProductForEdit({
                          ...selectedProductForEdit,
                          unit_price: e.target.value
                        })}
                        style={styles.input}
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Volume par unité (cl)</label>
                      <input
                        type="number"
                        value={selectedProductForEdit?.unit_volume_ml || ''}
                        onChange={(e) => setSelectedProductForEdit({
                          ...selectedProductForEdit,
                          unit_volume_ml: e.target.value
                        })}
                        style={styles.input}
                      />
                    </div>
                  </>
                )}
              </>
            )}

            {/* Prix pour nourriture */}
            {selectedProductForEdit?.product_category === 'food' && (
              <div style={styles.inputGroup}>
                <label style={styles.label}>Prix (€)</label>
                <input
                  type="number"
                  step="0.01"
                  value={selectedProductForEdit?.unit_price || ''}
                  onChange={(e) => setSelectedProductForEdit({
                    ...selectedProductForEdit,
                    unit_price: e.target.value
                  })}
                  style={styles.input}
                />
              </div>
            )}

            {/* Mode de service */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Mode de service</label>
              <select
                value={selectedProductForEdit?.service_mode || 'pickup'}
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  service_mode: e.target.value
                })}
                style={styles.input}
              >
                <option value="pickup">Sur place uniquement</option>
                <option value="delivery">Livraison uniquement</option>
                <option value="both">Les deux (sur place et livraison)</option>
              </select>
            </div>

            {/* Prix différenciés quand service_mode = 'both' */}
            {selectedProductForEdit?.service_mode === 'both' && (
              <>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Prix sur place (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={selectedProductForEdit?.unit_price_pickup || ''}
                    onChange={(e) => setSelectedProductForEdit({
                      ...selectedProductForEdit,
                      unit_price_pickup: e.target.value
                    })}
                    style={styles.input}
                    placeholder="Laisser vide pour utiliser le prix principal"
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Prix livraison (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={selectedProductForEdit?.unit_price_delivery || ''}
                    onChange={(e) => setSelectedProductForEdit({
                      ...selectedProductForEdit,
                      unit_price_delivery: e.target.value
                    })}
                    style={styles.input}
                    placeholder="Laisser vide pour utiliser le prix principal"
                  />
                </div>
              </>
            )}

            {/* Réduction */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Réduction (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                value={selectedProductForEdit?.discount || ''}
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  discount: e.target.value
                })}
                style={{
                  ...styles.input,
                  borderColor: (selectedProductForEdit?.discount < 0 || selectedProductForEdit?.discount > 100) ? '#dc2626' : '#d1d5db'
                }}
              />
              {(selectedProductForEdit?.discount < 0 || selectedProductForEdit?.discount > 100) && (
                <span style={{ color: '#dc2626', fontSize: '14px' }}>
                  La réduction doit être entre 0 et 100%
                </span>
              )}
            </div>

            {/* Nouvelle image */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Nouvelle image</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setSelectedProductForEdit({
                  ...selectedProductForEdit,
                  imageFile: e.target.files[0]
                })}
                style={styles.input}
              />
              {selectedProductForEdit?.imageFile && (
                <img
                  src={URL.createObjectURL(selectedProductForEdit.imageFile)}
                  alt="Aperçu"
                  style={{
                    width: '120px',
                    height: '90px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    marginTop: '8px'
                  }}
                />
              )}
            </div>

            {/* Actions du modal */}
            <div style={styles.modalActions}>
              <button
                onClick={closeEditModal}
                style={{
                  ...styles.button,
                  ...styles.secondaryButton
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#e2e8f0';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                }}
              >
                Annuler
              </button>
              <button
                onClick={() => handleEditSubmit(selectedProductForEdit)}
                style={{
                  ...styles.button,
                  ...styles.primaryButton
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#047857';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#059669';
                }}
              >
                Enregistrer les modifications
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ManageProductsPage;